import {CALL_TRACKING_SERVICES, DEFAULT_CULTURE, ORDER, SORT_FIELDS} from '../base.js'
import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  BODY_TYPE_4X4_ID,
  BODY_TYPE_CABRIO_ID,
  BODY_TYPE_COUPE_ID,
  BODY_TYPE_FAMILIAR_ID,
  BODY_TYPE_MINIVAN_ID,
  BODY_TYPE_PICK_UP_ID,
  BODY_TYPE_SEDAN_ID,
  BODY_TYPE_VANS_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CATEGORY2_ID_ALL_TERRAIN_VEHICLE,
  CATEGORY2_ID_AUTOCARAVAN,
  CATEGORY2_ID_BUS,
  CATEGORY2_ID_CAR,
  CATEGORY2_ID_CARAVAN,
  CATEGORY2_ID_CLASSIC,
  CATEGORY2_ID_COMPETITION,
  CATEGORY2_ID_LICENSES_AND_TRANSPORT_CARDS,
  CATEGORY2_ID_RENTAL,
  CATEGORY2_ID_SERVICES_GARAGE,
  CATEGORY2_ID_TRAILER_2,
  CATEGORY2_ID_TRUCK,
  CATEGORY2_ID_TUNING,
  CATEGORY2_ID_VAN,
  CATEGORY2_ID_WITHOUT_DRIVING_LICENSE,
  CLASSIC_AND_COMPETITION_CATEGORY1_ID,
  COLORS_ID,
  DEFAULT_OFFER_TYPE_ID,
  DRIVEN_WHEELS_ALL_ID,
  DRIVEN_WHEELS_FRONT_ID,
  DRIVEN_WHEELS_REAR_ID,
  ENVIRONMENTAL_LABELS_0_ID,
  ENVIRONMENTAL_LABELS_B_ID,
  ENVIRONMENTAL_LABELS_C_ID,
  ENVIRONMENTAL_LABELS_ECO_ID,
  FUEL_TYPE_CNG_ID,
  FUEL_TYPE_DIESEL_ID,
  FUEL_TYPE_ELECTRIC_ID,
  FUEL_TYPE_GASOLINE_ID,
  FUEL_TYPE_GLP_ID,
  FUEL_TYPE_HYBRID_ID,
  FUEL_TYPE_HYBRID_PLUG_IN_ID,
  FUEL_TYPE_OTHER_ID,
  LUGGAGE_CAPACITY_LARGE,
  LUGGAGE_CAPACITY_MEDIUM,
  LUGGAGE_CAPACITY_SMALL,
  OFFER_TYPE_DEMONSTRATION,
  OFFER_TYPE_KM0,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_NEW,
  OFFER_TYPE_PRE_OWNED,
  OFFER_TYPE_RENTAL,
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_SUBSCRIPTION,
  OFFER_TYPE_SUBSTITUTION,
  RECOMMENDATIONS_TARGETS,
  SEGUNDA_MANO_CATEGORY1_ID,
  TRANNSMISSION_TYPE_ID_AUTOMATIC,
  TRANNSMISSION_TYPE_ID_MANUAL,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './ads.js'
import {C2B_ORIGINS} from './c2b.js'
import {SELLER_TYPE_PRIVATE, SELLER_TYPE_PROFESSIONAL} from './dealer.js'
import {
  ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
  ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME,
  ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  ADS_LIST_PAGE_NAME,
  ADS_LIST_SUBSCRIPTION_PAGE_NAME,
  ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME,
  HOME_PAGE_NAME
} from './page.js'
import {PRICE_INDICATOR_LABEL_RANK} from './priceIndicator.js'
import {BENEFITS_CARDS_TABS} from './seller.js'
import {USER_CONSENTS} from './user.js'

export const XITI_IS_ENABLED = false
export const IS_BRAZE_ENABLED = true

export const ADS_NAME_PAGE_HOME = 'cochesnet/home'
export const ADS_NAME_PAGE_NEWS = 'cochesnet/noticias/home'
export const ADS_NAME_PAGE_NEWS_DETAIL = 'cochesnet/noticias/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS = 'cochesnet/fichastecnicas/home'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_HOME = 'cochesnet/fichastecnicas/home'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_COMPARATOR = 'cochesnet/fichastecnicas/comparativa'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_COMPARATOR_RESULTS = 'cochesnet/fichastecnicas/comparativa'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_MAKE = 'cochesnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_MODEL = 'cochesnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_BODY_TYPE = 'cochesnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_VERSION = 'cochesnet/fichastecnicas/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_VEHICLE = 'cochesnet/fichastecnicas/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_SEARCH = 'cochesnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_SEARCH_RESULTS = 'cochesnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_LANDING_FORMALITIES = 'cochesnet/tramites'
export const ADS_NAME_PAGE_LANDING_FORMALITIES_SECURITY_GUIDELINES = 'cochesnet/seguridad/tramites'
export const ADS_NAME_PAGE_ADS_DETAIL = 'cochesnet/ocasion/ficha'
export const ADS_NAME_PAGE_LANDING_FINANCING = 'cochesnet/financiacion'

export const PAGE_VIEW_EVENT = 'Page Viewed'
export const LIST_VIEW_EVENT = 'List Viewed'
export const LIST_TRIGGERED_EVENT = 'Lead Triggered'
export const INSURANCES_VIEW_EVENT = 'Insurances Viewed'
export const LIST_FILTERS_VIEW_EVENT = 'Filters Viewed'
export const RATINGS_VIEWED_EVENTS = 'Valoraciones Viewed'
export const NAVIGATION_MENU_ITEM_CLICKED_EVENT_NAME = 'Menu Item Clicked'
export const FILTER_EVENT_NAME = 'ad_filter'

export const EVENT_NAME = 'homepage'
export const HOME_EVENT_NAME = 'homepage'
export const LOGIN_NAME_PAGE_NEWS = ''
export const LOGIN_EVENT_NAME = 'login'
export const LANDING_SELLER_EVENT_NAME = 'sell_your_car'
export const LANDING_FORMALITIES_EVENT_NAME = 'search_advices'
export const LANDING_FORMALITIES_SECURITY_GUIDELINES_EVENT_NAME = 'buying_safely'
export const LANDING_FINANCING_EVENT_NAME = 'search_financing'
export const CHECKOUT_EVENT_NAME = 'checkout'
export const CHECKOUT_SUCCESS_EVENT_NAME = 'checkout_success'
export const CHECKOUT_ERROR_EVENT_NAME = 'checkout_error'
export const CHECKOUT_PENDING_EVENT_NAME = 'checkout_pending'
export const CHECKOUT_ACTIVATION_ERROR_EVENT_NAME = 'checkout_activation_error'
export const CHECKOUT_REFUND_ERROR_EVENT_NAME = 'checkout_refund_error'
export const CHECKOUT_REQUEST_ERROR_EVENT_NAME = 'checkout_request_error'
export const CHECKOUT_UNKNOWN_ERROR_EVENT_NAME = 'checkout_unknown_error'
export const PAYMENT_AD_REQUEST_EVENT_NAME = 'pay_ad'
export const TIPS_EVENT_NAME = 'editorial_consejos'
export const USER_FAVORITE_ADS_EVENT_NAME = 'my_saved_ads'
export const PRODUCTS_EVENT_NAME = 'bump_webpage'
export const PUBLISH_YOUR_VEHICLE_EVENT_NAME = 'Ad Insertion Viewed'
export const ADS_LIST_MAKE_EVENT_NAME = 'list'
export const ADS_DETAIL_EVENT_NAME = 'detail'
export const TECHNICAL_DETAILS_EVENT_NAME = 'technical_details'
export const TECHNICAL_DETAILS_HOME_EVENT_NAME = 'technical_details'
export const TECHNICAL_DETAILS_COMPARATOR_EVENT_NAME = 'technicaldetails_comparecars'
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_EVENT_NAME = 'comparison_result'
export const TECHNICAL_DETAILS_MAKE_EVENT_NAME = 'technicaldetails_brand'
export const TECHNICAL_DETAILS_MODEL_EVENT_NAME = 'technicaldetails_model'
export const TECHNICAL_DETAILS_BODY_TYPE_EVENT_NAME = 'technicaldetails_brand_listing'
export const TECHNICAL_DETAILS_VERSION_EVENT_NAME = 'technicaldetails_version'
export const TECHNICAL_DETAILS_VEHICLE_EVENT_NAME = 'technicaldetails_vehicle'
export const TECHNICAL_DETAILS_SEARCH_EVENT_NAME = 'technicaldetails_adv_search'
export const TECHNICAL_DETAILS_SEARCH_RESULTS_EVENT_NAME = 'technicaldetails_adv_search'
export const TERMS_OF_SERVICE_EVENT_NAME = 'terms-and-conditions'
export const TERMS_OF_SERVICE_ADS_NAME_PAGE = ''

export const CRITEO_ACCOUNT_ID = [16413, 21384, 44782]
export const CRITEO_VENTA_ACCOUNT_ID = 97204
export const TRACKING_EVENTS_THAT_NEED_IDENTIFY = [
  'Account Edited',
  'Filter Added',
  'Ad Favorited',
  'Topbar Ad Favorited',
  'My Messaging Phone Sent',
  'Onboarding Buyer Clicked',
  'Onboarding Seller Clicked',
  'Onboarding Cross Clicked',
  'Signed In',
  'Signed Up'
]
export const SEARCH_FILTERS_AS_STRING_TYPES = [
  'kmMax',
  'kmMin',
  'powerMin',
  'powerMax',
  'priceMax',
  'priceMin',
  'doors'
]
export const TRACKING_DATA_BY_SITE = {
  vertical: 'motor',
  site: 'coches.net',
  platform: 'web'
}
export const COMMON_ADS_LIST = {
  channel: 'ads',
  page_type: 'list',
  event: LIST_VIEW_EVENT
}

// According to Messaging tracking documentation
// https://docs.mpi-internal.com/tnt-messaging/messaging-fe-widget/docs/docs/features/tracking/
export const MESSAGING_AD_VIEW_EVENT = 'Ad View'
export const MESSAGING_BLOCK_USER_CHAT_EVENT = 'Block user chat'
export const MESSAGING_BLOCK_USER_INBOX_EVENT = 'Block user inbox'
export const MESSAGING_CHAT_VIEW_EVENT = 'Chat view'
export const MESSAGING_DELETION_CHAT_EVENT = 'Conversation deletion chat'
export const MESSAGING_DELETION_INBOX_EVENT = 'Conversation deletion inbox'
export const MESSAGING_SEND_EVENT = 'Message sent'
export const MESSAGING_SEND_BUTTON_CLICKED_EVENT = 'SEND_BUTTON_CLICKED'

export const MESSAGING_EVENT_NAMES = {
  [MESSAGING_AD_VIEW_EVENT]: 'My Messaging Ad Clicked',
  [MESSAGING_BLOCK_USER_CHAT_EVENT]: 'My Messaging User Blocked',
  [MESSAGING_BLOCK_USER_INBOX_EVENT]: 'My Messaging User Blocked',
  [MESSAGING_CHAT_VIEW_EVENT]: 'My Messaging Inbox Conversation Opened',
  [MESSAGING_DELETION_CHAT_EVENT]: 'My Messaging Conversation Deleted',
  [MESSAGING_DELETION_INBOX_EVENT]: 'My Messaging Conversation Deleted',
  [MESSAGING_SEND_EVENT]: 'Message Sent',
  [MESSAGING_SEND_BUTTON_CLICKED_EVENT]: 'Message Sent Clicked'
}

const SELLER_SELECTOR_TRACKING_EVENT_NAMES = {
  ACCESS_TO_AD_INSERTION_CLICKED: 'Access To Ad Insertion Clicked',
  ACCESS_TO_EDITORIAL_CLICKED: 'Access To Editorial Clicked',
  ACCESS_TO_INSTANT_OFFER_CLICKED: 'Access To Instant Offer Clicked',
  ACCESS_TO_TASADOR_CLICKED: 'Access To Tasador Clicked',
  BENEFITS_OF_SELLING_TO_PRIVATE_CLICKED: 'Seller Selector To Private Clicked',
  BENEFITS_OF_SELLING_TO_PROFESSIONAL_CLICKED: 'Seller Selector To Professional Clicked',
  ACCESS_TO_PROFESIONAL_LANDING_CLICKED: 'Access To Professional Landing Clicked'
}

export const SELLER_SELECTOR_BENEFITS_TABS_TRACKING_EVENT_NAMES = {
  [BENEFITS_CARDS_TABS.BENEFITS_OF_SELLING_TO_PRIVATE]:
    SELLER_SELECTOR_TRACKING_EVENT_NAMES.BENEFITS_OF_SELLING_TO_PRIVATE_CLICKED,
  [BENEFITS_CARDS_TABS.BENEFITS_OF_SELLING_TO_PROFESSIONAL]:
    SELLER_SELECTOR_TRACKING_EVENT_NAMES.BENEFITS_OF_SELLING_TO_PROFESSIONAL_CLICKED
}

const VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES = {
  VEHICLE_CONFIGURATOR_NEXT_SUCCESS: 'Car Configurator Next Button Success',
  VEHICLE_CONFIGURATOR_NEXT_ERROR: 'Car Configurator Next Button Error',
  VEHICLE_CONFIGURATOR_BACK: 'Car Configurator Back Button Clicked',
  VEHICLE_CONFIGURATOR_RETRY: 'Car Configurator Next Button Success'
}

const TRANSACTION_TRACKING_EVENT_NAMES = {
  BUYER_PAYCAR_LEGAL_CONDITIONS_ERROR_TRANSACTION: 'Pay Car Buyer Legal Conditions Error',
  BUYER_PAYCAR_PAYMENT_START_CLICKED_TRANSACTION: 'Pay Car Buyer Payment Start Clicked',
  BUYER_PAYCAR_PRICE_CONFIRMED_TRANSACTION: 'Pay Car Buyer Price Confirmed',
  BUYER_PAYCAR_PRICE_REFUSED_TRANSACTION: 'Pay Car Buyer Price Refused',
  BUYER_PAYCAR_SAFE_PURCHASE_CLICKED_TRANSACTION: 'Pay Car Buyer Safe Purchase Clicked',
  BUYER_PAYCAR_START_CLICKED_TRANSACTION: 'Pay Car Buyer Start Clicked',
  SELLER_IDENTITY_VALIDATION_FLOW_ERROR: 'Seller Identity Validation Flow Error',
  SELLER_PAYCAR_PRICE_CONFIRMED_TRANSACTION: 'Pay Car Seller Price Confirmed',
  SELLER_PAYCAR_SAFE_PURCHASE_CLICKED_TRANSACTION: 'Pay Car Seller Safe Purchase Clicked',
  SELLER_PAYCAR_SAFE_PURCHASE_REFUSED_TRANSACTION: 'Pay Car Seller Safe Purchase Refused',
  SELLER_PAYCAR_START_CLICKED_TRANSACTION: 'Pay Car Seller Start Clicked',
  SELLER_PAYCAR_LEGAL_CONDITIONS_ERROR_TRANSACTION: 'Pay Car Seller Legal Conditions Error',
  VALIDATION_BUYER_IDENTITY_ADD_PERSONAL_INFORMATION_CLICKED_TRANSACTION:
    'Validation Buyer identity Add personal information Clicked',
  VALIDATION_BUYER_IDENTITY_ADD_PERSONAL_INFORMATION_APPLICATION_ERROR_TRANSACTION:
    'Validation Buyer identity Add personal information application Error',
  VALIDATION_BUYER_IDENTITY_ADD_PROFESSIONAL_ACTIVITY_CLICKED_TRANSACTION:
    'Validation Buyer identity Add professional Activity Clicked',
  VALIDATION_BUYER_IDENTITY_ADD_PROFESSIONAL_ACTIVITY_ERROR_TRANSACTION:
    'Validation Buyer identity Add professional Activity Error'
}

export const VEHICLE_SUGGESTER_TRACKING_ACTIONS = {
  NEXT_BUTTON_CLICKED: 'next-button-clicked',
  BACK_BUTTON_CLICKED: 'back-button-clicked',
  NEXT_BUTTON_CLICKED_ERROR: 'next-button-clicked-error',
  DETAIL_CLICK: 'detail-click',
  CONFIGURE_CLICK: 'configure-click'
}

const AD_COMPLAINT_EVENT_NAMES = {
  AD_REPORTED: 'Ad Reported',
  AD_REPORTED_ERROR: 'Ad Reported Error',
  REPORT_AD_VIEWED: 'Report Ad Viewed'
}

export const REQUEST_STATUS_AI_SUCCESS = 'SUCCESS'

export const TRACKING_EVENT_AI_MAPPING = {
  GENERIC_ERROR: 'Generic error',
  NO_CONTENT_ERROR: 'Query correct but error in creating filters',
  GATEWAY_TIMEOUT_ERROR: 'Bedrock timeout',
  INTERNAL_SERVER_ERROR_ERROR: 'Server error',
  [REQUEST_STATUS_AI_SUCCESS]: 'success',
  UNAVAILABLE_FOR_LEGAL_REASONS_ERROR: 'Unethical query',
  UNPROCESSABLE_CONTENT_ERROR: 'Irrelevant query'
}

export const AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED_VARIANTS = {
  DOCUMENTATION: 'ver documentacion IO',
  FAQS: 'preguntas frecuentes IO'
}

export const AD_INSERTION_IO_FAQ_EXPANDED_VARIANTS = {
  CAN_I_MODIFY_THE_APPOINTMENT: 'puedo modificar cita',
  HAVE_I_A_COMMITMENT: 'compromisos',
  IS_IT_FREE: 'servicio gratuito',
  WHEN_I_GET_PAID: 'cuando recibire pago'
}

const AD_INSERTION_TRACKING_NAMES = {
  AD_INSERTION_IO_ADD_TO_CALENDAR: 'Ad Insertion IO Add To Calendar',
  AD_INSERTION_IO_BUTTON_CLICKED: 'Ad Insertion IO Button Clicked',
  AD_INSERTION_IO_CAR_DETAILS_ERROR: 'Ad Insertion IO Car Details Error',
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS: 'Ad Insertion IO Car Details Success',
  AD_INSERTION_IO_CAR_DETAILS_VIEWED: 'Ad Insertion IO Car Details Viewed',
  AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED: 'Ad Insertion IO Confirmation Faq Expanded',
  AD_INSERTION_IO_CONFIRMATION_VIEWED: 'Ad Insertion IO Confirmation Viewed',
  AD_INSERTION_IO_DATE_CONFIRMED: 'Ad Insertion IO Date Confirmed',
  AD_INSERTION_IO_DATE_ERROR: 'Ad Insertion IO Date Error',
  AD_INSERTION_IO_DATE_SELECTED: 'Ad Insertion IO Date Selected',
  AD_INSERTION_IO_DATES_VIEWED: 'Ad Insertion IO Dates Viewed',
  AD_INSERTION_IO_DEALER_ORDER_SELECTED: 'Ad Insertion IO Dealer Order Selected',
  AD_INSERTION_IO_DEALERS_VIEWED: 'Ad Insertion IO Dealers Viewed',
  AD_INSERTION_IO_FAQ_EXPANDED: 'Ad Insertion IO Faq Expanded',
  AD_INSERTION_IO_GO_TO_MY_ADS_CLICKED: 'Ad Insertion IO Go To My Ads Clicked',
  AD_INSERTION_IO_MAP_CLICKED: 'Ad Insertion IO Map Clicked',
  AD_INSERTION_IO_MODAL_VIEWED: 'Ad Insertion IO Modal Viewed',
  AD_INSERTION_IO_NO_INTERESA_BUTTON_CLICKED: 'Ad Insertion IO No Interesa Button Clicked',
  AD_INSERTION_IO_NO_OFFER_AVAILABLE: 'Ad Insertion IO No Offer Available',
  AD_INSERTION_IO_POSTAL_CODE_CHANGED: 'Ad Insertion IO Postal Code Changed',
  AD_INSERTION_IO_PUBLISH_AD_CLICKED: 'Ad Insertion IO Publish Ad Clicked',
  AD_INSERTION_IO_VIDEO_PLAYED: 'Ad Insertion IO Video Played',
  AD_INSERTION_IO_WHATSAPP_ACTION: 'Ad Insertion IO Whatsapp Action',
  AD_INSERTION_MODAL_DISMISSED: 'Ad Insertion Modal Dismissed',
  AD_INSERTION_MODAL_VIEWED: 'Ad Insertion Modal Viewed',
  AD_INSERTION_IO_DEALER_SELECTED: 'Ad Insertion IO Dealer Selected',
  AD_INSERTION_IO_HOUR_SELECTED: 'Ad Insertion IO Hour Selected'
}

const INSTANT_OFFER_TRACKING_NAMES = {
  INSTANT_OFFER_FIELD_SELECTED: 'Instant Offer Field Selected',
  INSTANT_OFFER_MODAL_VIEWED: 'Instant Offer Modal Viewed'
}

export const USER_CONSENTS_TRACKING_EVENT_NAMES = {
  USER_CONSENT_FINANCIAL_SERVICES_CLICKED: 'Financial Services User Consent Clicked',
  USER_CONSENT_WHATSAPP_COMMUNICATIONS_CLICKED: 'Whatsapp Communications User Consent Clicked',
  USER_CONSENT_PORTAL_ANNOUNCEMENTS_CLICKED: 'Portal Announcements User Consent Clicked',
  USER_CONSENT_EXTERNAL_SERVICES_OFFERS_CLICKED: 'External Services Offers User Consent Clicked',
  USER_CONSENT_SEGMENTED_ADS_CLICKED: 'Segmented Ads User Consent Clicked'
}

export const USER_CONSENTS_TRACKING_EVENT_NAMES_MAPPING = {
  [USER_CONSENTS.FINANCIAL_SERVICES]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_FINANCIAL_SERVICES_CLICKED,
  [USER_CONSENTS.WHATSAPP_COMMUNICATIONS_C2B]:
    USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_WHATSAPP_COMMUNICATIONS_CLICKED,
  [USER_CONSENTS.PORTAL_ANNOUNCEMENTS]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_PORTAL_ANNOUNCEMENTS_CLICKED,
  [USER_CONSENTS.EXTERNAL_SERVICES_OFFERS]:
    USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_EXTERNAL_SERVICES_OFFERS_CLICKED,
  [USER_CONSENTS.SEGMENTED_ADS]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_SEGMENTED_ADS_CLICKED
}

const LANDING_INSTANT_OFFER_TRACKING_NAMES = {
  LANDING_IO_DATE_CONFIRMED: 'Landing IO Date Confirmed',
  LANDING_IO_FIELD_AUTOCOMPLETED: 'Landing IO Field Autocompleted',
  LANDING_IO_FIELD_SELECTED: 'Landing IO Field Selected',
  LANDING_IO_FORM_FIELDS_ERROR: 'Landing IO Form Fields Error',
  LANDING_IO_NEXT_CONFIRMED: 'Landing IO Next Confirmed',
  LANDING_IO_NEXT_ERROR: 'Landing IO Next Error',
  LANDING_IO_NEXT_VIEWED: 'Landing IO Form Page 2 Viewed',
  LANDING_IO_OFFER_REQUESTED_ERROR: 'Landing IO Offer Requested Error',
  LANDING_IO_OFFER_REQUESTED: 'Landing IO Offer Requested'
}

const VISIBILITY_PRODUCTS_TRACKING_NAMES = {
  VISIBILITY_PRODUCTS_BUTTON_CLICKED: 'Visibility Products Button Clicked'
}

const FAVORITES_TRACKING_NAMES = {
  FAVORITES_VEHICLES_TAB_CLICKED: 'Favorite Vehicles Tab Clicked',
  FAVORITES_DEALER_TAB_CLICKED: 'Favorite Dealers Tab Clicked',
  DEALER_FAVORITED: 'Dealer Favorited',
  DEALER_UNFAVORITED: 'Dealer Unfavorited',
  FAVORITES_DEALER_CARD_CLICKED: 'Dealer Stock Clicked'
}

const NET_ASSISTANT_TRACKING_NAMES = {
  NET_ASSISTANT_CLOSED: 'Net Closed',
  NET_ASSISTANT_WELCOME_CTA_CLICKED: 'Net Predefined Question Clicked',
  NET_ASSISTANT_MICROPHONE_CLICKED: 'Net Microphone Clicked',
  NET_ASSISTANT_MESSAGE_SENT: 'Net Message Sent',
  NET_ASSISTANT_NEW_CHAT_CLICKED: 'Net New Conversation Clicked',
  NET_ASSISTANT_ACCESS_CLICKED: 'Net Access Clicked',
  NET_ASSISTANT_ANSWER_CLICKED: 'Net Answer Clicked',
  NET_ASSISTANT_REVIEW_SENT: 'Net Review Sent',
  NET_ASSISTANT_REVIEW_DETAIL_SENT: 'Net Review Detail Sent',
  NET_ASSISTANT_END_CONVERSTAION_VIEWED: 'Net End Conversation Viewed',
  NET_ASSISTANT_RETRY_VIEWED: 'Net Retry Viewed',
  NET_ASSISTANT_RETRY_CLICKED: 'Net Retry Clicked',
  NET_MENU_CLICKED: 'Net Menu Clicked',
  NET_FULL_SCREEN_CLICKED: 'Net Full Width Clicked',
  NET_FULL_SCREEN_EXIT_CLICKED: 'Net Full Width Exit Clicked',
  NET_ACCESS_HOME_CLICKED: 'Net Access Home Clicked'
}

export const TRACKING_EVENT_NAMES = {
  ACCOUNT_DELETE_CLICKED: 'Privacy Configuration Delete My Data Clicked',
  ACCOUNT_MANAGE_DATA_CLICKED: 'Privacy Configuration How We Manage Your Data Clicked',
  ACCOUNT_TAKEOUT_CLICKED: 'Privacy Configuration Download My Data Clicked',
  ACCOUNT_EDITED: 'Account Edited',
  ACCOUNT_EDITED_ERROR: 'Account Edited Error',
  AD_DETAIL_BUTTON_CLICKED: 'Detail Button Clicked',
  AD_DISCARDED: 'Ad Discarded',
  AD_DISCARDED_CLICK: 'Ad Discarded Clicked',
  AD_FAVORITED: 'Ad Favorited',
  AD_IMPRESSIONS_COLLECTED_EVENT: 'Ad Impressions Collected',
  AD_LIST_CLICKED: 'Ad List Clicked',
  AD_SHARE_DECLINE: 'Ad Shared Declined',
  AD_SHARE_MODAL_CLOSED: 'Ad Shared Modal Closed',
  AD_SHARE_MODAL_REJECT: 'Ad Shared Pop Up Rejected',
  AD_SHARED: 'Ad Shared',
  AD_SHARED_CLICKED: 'Ad Shared Clicked',
  AD_SUBSCRIPTION_PRICE_OPTION_CLICKED: 'Subscription Ad Price Option Clicked',
  AD_TO_COMPARE_ADDED: 'Comparator Vehicle Added',
  AD_TO_COMPARE_REMOVED: 'Comparator Vehicle Removed',
  AD_TO_COMPARE_MENU_CLICKED: 'Comparator Menu Clicked',
  AD_TO_COMPARE_SEE_RESULTS_CLICKED: 'Show Comparison Clicked',
  AD_UNFAVORITED: 'Ad Unfavorited',
  AD_VIDEO_BUTTON_CLICKED: 'Ad Video Button Clicked',
  AD_VIDEO_PLAYED: 'Ad Video Played',
  AI_SEARCH_USED: 'Ai Search Used',
  ALERT_CREATED: 'Alert Created',
  APP_DOWNLOAD_BUTTON_CLICKED: 'App Download Button Clicked',
  APP_SUGGESTION_DRAWER_CLICKED: 'Smartbanner Clicked',
  APP_SUGGESTION_DRAWER_VIEWED: 'Smartbanner Viewed',
  BUTTON_CLICKED: 'Button Clicked',
  DEALER_SERVICES_POPUP: 'Dealer Services Popup',
  DEALER_STOCK_CLICKED: 'Dealer Stock Clicked',
  DEALER_VIDEO_PLAYED: 'Dealer Video Played',
  DEALER_STOCK_SHARED: 'Stock Shared',
  DEALER_STOCK_SHARED_CLICKED: 'Stock Shared Clicked',
  DETAIL_GALLERY_CLICKED: 'Detail Gallery Clicked',
  DETAIL_NAVBAR_CLICKED: 'Detail Navbar Clicked',
  DETAIL_REVAMP_TEST_VIEWED: 'Detail Revamp Test Viewed',
  FILTER_ADDED: 'Filter Added',
  FILTER_PRICE_CHIP_USED: 'Filter Price Chip Used',
  FILTER_KM_CHIP_USED: 'Filter Km Chip Used',
  FINANCING_ADS_LIST_LEGAL_CONDITIONS_CLICKED: 'Ads List Financial Legal Conditions Clicked',
  FINANCING_CALCULATOR_ENTRY_FEE_SELECTED: 'Financing Calculator Entry Fee Selected',
  FINANCING_CALCULATOR_ENTRY_FEE_SELECTED_B2C: 'Financing Calculator Professional Seller Entry Fee Selected',
  FINANCING_CALCULATOR_TERM_SELECTED: 'Financing Calculator Term Selected',
  FINANCING_CALCULATOR_TERM_SELECTED_B2C: 'Financing Calculator Professional Seller Term Selected',
  FINANCING_CALCULATOR_LOAN_APPLICATION_CLICKED: 'Financing Calculator Loan Application Clicked',
  FINANCING_CALCULATOR_LOAN_APPLICATION_CLICKED_B2C:
    'Financing Calculator Professional Seller Loan Application Clicked',
  FINANCING_CALCULATOR_LOAN_APPLICATION_FAILED_B2C: 'Financing Calculator Professional Seller Loan Application Error',
  FINANCING_CALCULATOR_LOAN_DATA_VISUALIZED: 'Financing Calculator Loan Data Visualized',
  FINANCING_DETAIL_LEGAL_CONDITIONS_CLICKED: 'Detail Financial Legal Conditions Clicked',
  FINANCING_CALCULATOR_CLICKED: 'Financing Calculator Professional Seller Clicked',
  FINANCING_PRI_CALCULATOR_CLICKED: 'Financing Calculator Private Seller Clicked',
  GOOGLE_ONE_TAP_SEEN: 'Google One Tap Seen',
  GOOGLE_ONE_TAP_STARTED: 'Google One Tap Started',
  INSTANT_OFFER_FORM_VIEWED: 'Instant Offer Form Viewed',
  LEAD_ENRICHED: 'Lead Enriched',
  LEAD_ERROR: 'Lead Error',
  MARKET_PLAYERS_ACTIONS_CLICK: 'Home Selector Tab Clicked',
  MARKET_PLAYERS_SERVICES_TAB: 'Accompaniment Home Selector Tab Clicked',
  MARKET_PLAYERS_SERVICES_CARD: 'Accompaniment Section Button Clicked',
  MODEL_DETAIL_HOME_CLICKED_EVENT: 'Model Detail Home Clicked',
  MODEL_DETAIL_HOME_SEARCH_CLICKED_EVENT: 'Model Detail Home Search Clicked',
  NAVIGATION_BETWEEN_CARDS_CLICKED: 'Navigation Between Cards Clicked',
  CONSUMPTION_DETAIL_CLICKED: 'Consumption Detail Clicked',
  EXTRA_EQUIPMENT_DETAIL_CLICKED: 'Extra Equipment Detail Clicked',
  MANUFACTURER_CERTIFIED_CLICKED: 'Certified Cars Program Clicked',
  PHOTO_DETAIL_CLICKED: 'Photo Detail Clicked',
  PRICE_DETAIL_CLICKED: 'Price Detail Clicked',
  RATINGS_VIEWED_EVENT: 'Ratings Viewed',
  SELLER_SERVICES_CLICKED: 'Dealer Services Pop Up',
  SEND_MESSAGE_BUTTON_CLICKED: 'Send Message Button Clicked',
  VEHICLE_HISTORY_CLICKED: 'Vehicle History Clicked',
  FREE_VEHICLE_HISTORY_CLICKED: 'Free Vehicle History Clicked',
  NEWSLETTER_CLICK: 'Receive Newsletter Clicked',
  NEWS_COMMENT_PUBLISH: 'News Commented',
  NEWS_COMMENT_REPLY: 'Reply News Comment',
  NEWS_SHARED_CLICKED: 'News Shared Clicked',
  NEWS_SHARED: 'News Shared',
  LIST_NEWS_SAVED_CLICKED: 'List News Saved Clicked',
  LIST_NEWS_SAVED_VIEWED: 'List News Saved Viewed',
  NEWS_VIDEO_PLAYED: 'News Video Played',
  PERSONAL_DATA_FORM_ERROR: 'Personal Data Form Error',
  PRICE_INDICATOR_CLICKED: 'Price Indicator Clicked',
  PROMOTIONAL_SLIDER_BANNER_CLICKED: 'Promotional Slider Banner Clicked',
  RATINGS_CLICKED: 'Valoraciones Clicked',
  RATINGS_VIEWED_EVENTS: 'Valoraciones Viewed',
  RECOMMENDATION_WIDGET_CLICKED: 'Recommendation widget clicked',
  RECOMMENDATION_WIDGET_IMPRESSION_EVENT: 'Recommendation widget impression',
  RECOMMENDATION_WIDGET_VIEWABLE_IMPRESSION: 'Recommendation widget viewable impression',
  RECOMMENDATION_WIDGET_VIEWED: 'Recommendation Widget Viewed',
  RESERVATION_INFORMATION_CLICKED: 'Reservation Information Clicked',
  RESET_PASSWORD_MODAL_CLOSE: 'Reset Password Modal Closed',
  SHORTCUT_LISTING_BUTTON_CLICKED: 'Shortcut Listing Button Clicked',
  SIGNED_IN_ERROR: 'Signed In Error',
  SIGNED_IN: 'Signed In',
  SIGNED_OUT: 'Signed Out',
  SIGNED_UP_ERROR: 'Signed Up Error',
  SIGNED_UP: 'Signed Up',
  SMARTBANNER_CLICKED: 'Smartbanner Clicked',
  SMARTBANNER_VIEWED: 'Smartbanner Viewed',
  SOCIAL_LOGIN_CLICKED_GOOGLE: 'Google Social Login Clicked',
  SOCIAL_LOGIN_CLICKED_APPLE: 'Apple Social Login Clicked',
  SUBSCRIPTION_CAROUSEL_CLICKED_EVENT: 'Listing Four Cards Carousel Clicked',
  USER_RATING_COMPLETED: 'User Rating Completed',
  USER_RATING_ERROR: 'User Rating Error',
  ...AD_COMPLAINT_EVENT_NAMES,
  ...AD_INSERTION_TRACKING_NAMES,
  ...INSTANT_OFFER_TRACKING_NAMES,
  ...LANDING_INSTANT_OFFER_TRACKING_NAMES,
  ...MESSAGING_EVENT_NAMES,
  ...SELLER_SELECTOR_TRACKING_EVENT_NAMES,
  ...TRANSACTION_TRACKING_EVENT_NAMES,
  ...USER_CONSENTS_TRACKING_EVENT_NAMES,
  ...VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES,
  ...VISIBILITY_PRODUCTS_TRACKING_NAMES,
  ...FAVORITES_TRACKING_NAMES,
  ...NET_ASSISTANT_TRACKING_NAMES
}

export const TRACKING_PAGE_ERRORS = {
  FIELD_ERROR: 'field error',
  NEW_AD_NO_TARGET: 'anuncio nuevo no target'
}

export const INSTANT_OFFER_FORM_NAMES_BY_C2B_ORIGINS = {
  DEFAULT: 'IO organico',
  [C2B_ORIGINS.INSTANT_OFFER_LANDING]: 'IO Landing',
  [C2B_ORIGINS.STANDALONE]: 'stand alone',
  [C2B_ORIGINS.VEHICLE_APPRAISER]: 'tasacion vehiculo'
}

export const C2B_FLOW_BY_ORIGINS = {
  [C2B_ORIGINS.BANNER_HOME]: 'c2b banner home',
  [C2B_ORIGINS.BANNER_HOME_TO_DEALERS]: 'c2b banner home to dealers',
  [C2B_ORIGINS.BANNER_HOME_TO_STANDALONE]: 'c2b banner home to standalone',
  [C2B_ORIGINS.CHAT]: 'c2b chat',
  [C2B_ORIGINS.PUBLISH_MY_AD]: 'c2b post pta',
  [C2B_ORIGINS.PUBLISHED_AD]: 'c2b my ads',
  [C2B_ORIGINS.STANDALONE]: 'c2b standalone',
  [C2B_ORIGINS.STANDALONE_EMPTY_CASE]: 'c2b standalone',
  [C2B_ORIGINS.INSTANT_OFFER_LANDING]: 'c2b landing',
  [C2B_ORIGINS.VEHICLE_APPRAISER]: 'c2b tasador',
  [C2B_ORIGINS.POST_LEAD]: 'c2b post lead'
}

const GALLERY_DETAIL_HIT_INFORMATIONS = {
  GALLERY_DETAIL_IMAGE: 'image',
  GALLERY_DETAIL_VIDEO: 'video',
  GALLERY_DETAIL_BUTTON: 'button'
}

const AD_DETAIL_HIT_INFORMATIONS = {
  AD_DETAIL_SHOW_DESCRIPTION: 'mostrar descripcion',
  AD_DETAIL_SHOW_EXTRAS: 'mostrar extras',
  AD_DETAIL_SHOW_TECHNICAL_DATASHEET: 'mostrar ficha tecnica',
  AD_DETAIL_SHOW_SELLER_ADDRESS: 'mostrar direccion'
}

const AD_INSERTION_HIT_INFORMATIONS = {
  C2B_VIDEO: 'c2b video',
  EMPTY_PLATE: 'matricula vacia',
  ONLINE_APPOINTMENT_INFO: 'informacion cita online',
  PTA_VIDEO: 'pta video',
  WRONG_PLATE: 'matricula incorrecta'
}

const INSTANT_OFFER_PAGE_HIT_INFORMATIONS = {
  HOW_INITIAL_APPRAISAL_IS_CALCULATED: 'como calculamos tasacion inicial',
  HOW_VEHICLE_VALUE_IS_CALCULATED: 'como se calcula valor vehiculo',
  NOT_INTERESTED_STANDALONE_PUBLISH_AD: 'no interesa standalone publicar anuncio',
  PUBLISH_VEHICLE: 'publicar vehículo',
  WHY_THERE_ARE_NOT_OFFERS: 'porque no hay ofertas',
  WEEK_SCHEDULE_CLICK_ON_A_DAY: 'click en un dia',
  WEEK_SCHEDULE_CLICK_ON_DEALER_NAME: 'click en el nombre',
  WEEK_SCHEDULE_CLICK_ON_MORE_DAYS: 'click en mas dias'
}

const NET_ASSISTANT_HIT_INFORMATIONS = {
  NET_ASSISTANT_HEADER_MENU: 'header menu',
  NET_ASSISTANT_SEARCH_BAR_DROPDOWN: 'search bar dropdown'
}

const SELLER_SELECTOR_HIT_INFORMATIONS = {
  EDITORIAL_HOW_TO_SELL: 'como vender un coche de segunda mano',
  EDITORIAL_HOW_TO_SELL_TO_DEALER: 'como funciona el proceso de venta a un profesional',
  EDITORIAL_HOW_TO_PUBLISH: 'como vender tu coche en coches.net',
  EDITORIAL_SELL_TO_DEALER: 'ventajas de vender tu coche a un profesional',
  EDITORIAL_SELL_TO_PRIVATE: 'tramites para compraventa de coches entre particulares'
}

const VISIBILITY_PRODUCTS_HIT_INFORMATIONS = {
  VISIBILITY_PRODUCTS_FAQS_EXPANDING: 'pregunta frecuente desplegada',
  VISIBILITY_PRODUCTS_BUY_QUICK_SALE: 'comprar venta rapida',
  VISIBILITY_PRODUCTS_BUY_TOP: 'comprar top',
  VISIBILITY_PRODUCTS_BUY_PACK_VISIBILITY: 'comprar pack visibilidad',
  VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS: 'como funciona venta rapida',
  VISIBILITY_PRODUCTS_HOW_TOP_WORKS: 'como funciona top',
  VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS: 'como funciona pack visibilidad'
}

export const HIT_INFORMATIONS = {
  ...GALLERY_DETAIL_HIT_INFORMATIONS,
  ...AD_DETAIL_HIT_INFORMATIONS,
  ...AD_INSERTION_HIT_INFORMATIONS,
  ADS_LIST_MENU_CLICKED: 'List 3 Point Menu Clicked',
  APP_SUGGESTION_DRAWER_CLOSE_ACTION: 'close',
  APP_SUGGESTION_DRAWER_INSTALL_ACTION: 'install',
  APP_SUGGESTION_DRAWER_POSITION_BOTTOM: 'bottom',
  EMAIL_AUTHENTICATION: 'email login',
  FINANCING_PRI_WITH_PLATE: 'Yes',
  FINANCING_PRI_WITHOUT_PLATE: 'No',
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
  GOOGLE_AUTHENTICATION: 'google',
  GOOGLE_LOGIN: 'social login google',
  SOCIAL_LOGIN_APPLE: 'social login apple',
  GREEN_MOBILITY: 'green',
  ...INSTANT_OFFER_PAGE_HIT_INFORMATIONS,
  LIFESTYLE_CATEGORIES: 'estilo de vida',
  MARKET_PLAYERS_ACTIONS_BUYER: 'Comprar',
  MARKET_PLAYERS_ACTIONS_SELLER: 'Vender',
  MARKET_PLAYERS_SERVICES_TAB_BUYER: 'comprar',
  MARKET_PLAYERS_SERVICES_TAB_SELLER: 'vender',
  MARKET_PLAYERS_SERVICES_TAB_OWNER: 'propietarios',
  NEWVEHICLE_MODELDETAIL_LEAD_GENERAL_INFO: 'General Information',
  NEWVEHICLE_MODELDETAIL_LEAD_TEST_DRIVE: 'Test Drive',
  NEXT: 'siguiente',
  ONLY_CHOICE: 'unica opcion',
  PRIVATE_AD: 'PRI',
  PREVIOUS: 'anterior',
  PROFESSIONAL_AD: 'PRO',
  PROMOTIONAL_SLIDER_BANNER: 'promotional slider banner',
  PTA: 'pta',
  SECOND_HAND_ELECTRIC: 'electrico ocasion',
  SECOND_HAND_HYBRID: 'hibrido ocasion',
  SECOND_HAND_HYBRID_PLUG_IN: 'hibrido enchufable ocasion',
  SMARTBANNER_CLOSE_ACTION: 'close',
  SMARTBANNER_POSITION_TOP: 'top',
  SMARTBANNER_POSITION_BOTTOM: 'bottom',
  STANDARD_LOGIN: 'email login',
  SUBSCRIPTION_AD_COMMITMENT_CLICKED: 'Subscription Commitment Button Clicked',
  SUBSCRIPTION_AD_KM_INCLUDED_CLICKED: 'Subscription Km Included Button Clicked',
  SUBSCRIPTION_CAROUSEL_AD_IMPRESSIONS_COLLECTED_MAKE: 'by brand carousel',
  SUBSCRIPTION_CAROUSEL_AD_IMPRESSIONS_COLLECTED_RANDOM: 'random carousel',
  SUBSCRIPTION_CAROUSEL_DETAIL_CLICKED: 'subscription detail clicked',
  SUBSCRIPTION_CAROUSEL_LISTING_CLICKED: 'subscription listing clicked',
  ...SELLER_SELECTOR_HIT_INFORMATIONS,
  TRANSACTION_PAYCAR_LEGAL_CONDITIONS_ERROR_ALL: 'All',
  TRANSACTION_PAYCAR_LEGAL_CONDITIONS_ERROR_NONE: 'None',
  TRANSACTION_PAYCAR_LEGAL_CONDITIONS_ERROR_PRIVACY: 'Privacy',
  TRANSACTION_PAYCAR_LEGAL_CONDITIONS_ERROR_TC: 'T&C',
  VEHICLE_CATEGORIES_SLIDER: 'categorias de vehiculos',
  VEHICLE_CONFIGURATOR: 'car configurator',
  ...VISIBILITY_PRODUCTS_HIT_INFORMATIONS,
  ...NET_ASSISTANT_HIT_INFORMATIONS
}

export const AUTHENTICATION_HIT_INFORMATIONS_2 = {
  COMPARATOR: 'comparador',
  NET: 'net assistant',
  DETAIL: 'detail',
  DEALER_STOCK_PAGE: 'dealer stock page'
}

const VISIBILITY_PRODUCTS_HIT_ORIGINS = {
  VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS: 'como funciona venta rapida',
  VISIBILITY_PRODUCTS_HOW_TOP_WORKS: 'como funciona top',
  VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS: 'como funciona pack visibilidad',
  VISIBILITY_PRODUCTS_PAGE: 'pagina productos visibilidad'
}

const NET_ASSISTANT_HIT_ORIGINS = {
  NET_ASSISTANT_LANDING: 'landing',
  NET_ASSISTANT_CONVERSATION: 'conversation',
  NET_ASSISTANT_NEW_CHAT: 'new conversation',
  NET_ASSISTANT_OLD_CHAT: 'old conversation',
  NET_ASSISTANT_AD: 'anuncio',
  NET_ASSISTANT_LISTING: 'listado',
  NET_ASSISTANT_AD_FAVORITED: 'Net Ad Favorited',
  NET_ASSISTANT_END_CONVERSATION: 'end conversation'
}

export const LEAD_ERROR_HIT_INFORMATIONS = {
  MESSAGE_NOT_SENT: 'Message not sent',
  MISSING_FIELDS: 'Missing fields'
}

export const HIT_ORIGINS = {
  AD_DETAIL: 'detail',
  APP_SUGGESTION_DRAWER_ADS_LIST: 'ads list',
  APP_SUGGESTION_DRAWER_HOME: 'homepage',
  AD_DETAIL_AD_DISCARDED: 'Detail Ad Discarded',
  AD_IMAGE_GALLERY_AD_DISCARDED: 'Image Gallery Ad Discarded',
  AD_LIST_AD_DISCARDED: 'List Ad Discarded',
  ADS_LIST_MENU_AD_DISCARDED: 'List 3p Menu Ad Discarded',
  AD_DETAIL_FAVORITED: 'Detail Ad Favorited',
  AD_DETAIL_FAVORITED_PRICE_DROP: 'Detail Price Drop Ad Favorited',
  AD_DETAIL_FAVORITED_TOPBAR: 'Detail Topbar Ad Favorited',
  AD_LIST_FAVORITED: 'List Ad Favorited',
  AD_LIST_MENU_FAVORITED_PRICEDROP: 'List 3p Menu Price Drop Ad Favorited',
  AD_SHARED_AFTER_FAVORITED_DETAIL: 'Detail After Favorited Ad Shared',
  ADS_LIST: 'listado de coches',
  ADS_LIST_AUTOCARAVANS_AND_TRAILERS: 'listado de autocaravanas y remolques',
  ADS_LIST_CARS_WITHOUT_LICENSE: 'listado de coches sin carnet',
  ADS_LIST_CLASSIC_AND_COMPETITION: 'listado de clasicos',
  ADS_LIST_MENU: 'List Ad',
  ADS_LIST_VANS_AND_COMMERCIAL: 'listado de industriales',
  ADS_LIST_SUBSCRIPTION: 'listado de coches por suscripcion',
  ADS_LIST_BUSINESS_SUBSCRIPTION: 'listado de coches por suscripcion empresas',
  ALERT_AD_FAVORITED: 'Alert Ad Favorited',
  APP_DOWNLOAD_FROM_COMPARATOR: 'download from car comparison',
  APP_DOWNLOAD_FROM_FOOTER: 'download from footer',
  APP_DOWNLOAD_FROM_LOGIN_MODAL: 'download from registration via topbar',
  APP_DOWNLOAD_FROM_POST_LEAD: 'download from post lead',
  COMPARATOR_AD_FAVORITED: 'Comparator',
  DEALER_PROVINCE_SEARCH_PHONE_CALLED: 'Dealer Province Search Phone Called',
  DEALER_SEARCH_PHONE_CALLED: 'Dealer Search Phone Called',
  DEFAULT_LOGIN: 'default login',
  LEAD_EMAIL: 'lead email',
  EMAIL: 'email',
  FAVORITES_PAGE: 'my favorites',
  FAVORITES_DEALER_PAGE: 'my favorite dealers page',
  FINANCING_CALCULATOR_CNET_ELEMENT: 'calculadora cnet',
  FINANCING_CALCULATOR_WIDGET_ELEMENT: 'Widget',
  FINANCING_CONTACT_FORM_ELEMENT: 'Contact Form',
  FINANCING_PRICE_ELEMENT: 'Price',
  GOOGLE_ONE_TAP: 'google one tap',
  HOME_PAGE: 'homepage',
  HOME_PAGE_SEARCH: 'homepage filters',
  HOME_POST_CONSENT_LOGIN: 'onboarding app new user',
  LIST: 'list',
  LIST_ADS_COMPARISON_MENU: 'comparison menu',
  LIST_ADS_COMPARISON_BOTTOM_SHEET: 'bottom sheet',
  NEWS_COMMENTED: 'News Below Commented',
  NEWS_DETAIL_REFERER: 'editorial web',
  NEWS_LIST: 'news',
  NEWS_SAVED_LIST: 'news saved',
  NEWSLETTER_NEWS_DETAIL_BODY: 'News body',
  NEWSLETTER_HOME: 'homepage',
  NEWSLETTER_NEWS_LIST: 'news list',
  NEWSLETTER_AD_DETAIL: 'ad detail',
  PTA: 'pta',
  RATING_LINK: 'link',
  RATING_TAB: 'tab',
  RATING_DETAIL: 'detail',
  RATING_DETAIL_CONTACT_FORM: 'detail contact form',
  SMARTBANNER_HOME: 'homepage',
  SMARTBANNER_ADS_LIST: 'ads list',
  SMARTBANNER_AD_DETAIL: 'ad detail',
  SMARTBANNER_NEWS_LIST: 'news list',
  SMARTBANNER_NEWS_DETAIL: 'news detail',
  SOCIAL_LOGIN: 'social login',
  SUBSCRIPTION_CAROUSEL_DETAIL_CLICKED: 'VO Listing',
  USER_PROFILE: 'mi cuenta',
  VEHICLE_CONFIGURATOR_NEXT_SUCCESS: VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES.VEHICLE_CONFIGURATOR_NEXT_SUCCESS,
  VEHICLE_CONFIGURATOR_NEXT_ERROR: VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES.VEHICLE_CONFIGURATOR_NEXT_ERROR,
  VEHICLE_CONFIGURATOR_BACK: VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES.VEHICLE_CONFIGURATOR_BACK,
  VEHICLE_CONFIGURATOR_RETRY: VEHICLE_CONFIGURATOR_TRACKING_EVENT_NAMES.VEHICLE_CONFIGURATOR_RETRY,
  VEHICLE_CONFIGURATOR: 'car configurator',
  FDA_CALCULATOR: 'con calculadora',
  FDA_NO_CALCULATOR: 'sin calculadora',
  LEAD_WHATSAPP: 'lead whatsapp',
  TOP_BAR_BUTTON: 'top bar button',
  AD_FAVORITED: 'add ad favorited',
  DEALER_FAVORITED: 'add dealer favorited',
  PRICE_DROP_SAVED: 'save price drop',
  AD_DISCARDED: 'ad discarded',
  NEWSLETTER_SUBSCRIPTION: 'subscribe newsletter',
  NEWS_COMMENT: 'comment from editorial',
  MY_ACCOUNT: 'my account',
  SEARCH_SAVED: 'save search',
  CONFIGURATOR: 'configurator',
  RESERVATION: 'reservation',
  OTHERS: 'others',
  LOGIN_PAGE: 'login page',
  DETAIL_PAGE: 'detail_page',
  DETAIL_DRAWER: 'detail_drawer',
  DETAIL_PAGE_CONTACT_DRAWER: 'detail_page_contact_drawer',
  CHAT_LEAD: 'chat lead',
  AD_REPLIED_EMAIL_ALERT_CREATED: 'Ad Replied Email Alert Created',
  ...VISIBILITY_PRODUCTS_HIT_ORIGINS,
  ...NET_ASSISTANT_HIT_ORIGINS
}

export const SEARCH_AI_USED_HIT_ORIGINS_BY_PAGE_NAME = {
  [ADS_LIST_PAGE_NAME]: HIT_ORIGINS.ADS_LIST,
  [ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_AUTOCARAVANS_AND_TRAILERS,
  [ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_CARS_WITHOUT_LICENSE,
  [ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_CLASSIC_AND_COMPETITION,
  [ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_VANS_AND_COMMERCIAL,
  [ADS_LIST_SUBSCRIPTION_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_SUBSCRIPTION,
  [HOME_PAGE_NAME]: HIT_ORIGINS.HOME_PAGE
}

export const LIST_TYPES = {
  NET_ASSISTANT_CAROUSEL: 'carrousel respuesta net',
  NET_ASSISTANT_AD_CARD: 'ad card respuesta net',
  RECOMMENDATIONS_DEALER_RATING_NOT_ANSWERED: 'dealer rating not answered anuncios recomendados',
  RENTING_PRIVATE_TARGET_BUYER: 'listado de coches por suscripcion',
  RENTING_BUSINESS_TARGET_BUYER: 'listado de coches por suscripcion empresas'
}

export const LIST_TYPES_BY_RENTING_TARGET_BUYER = {
  BUSINESS: LIST_TYPES.RENTING_BUSINESS_TARGET_BUYER,
  PRIVATES: LIST_TYPES.RENTING_PRIVATE_TARGET_BUYER
}

export const RECOMMENDATIONS_PAGE_LIST_TYPES_BY_TARGET = {
  [RECOMMENDATIONS_TARGETS.DEALER_NO_RESPONSE]: LIST_TYPES.RECOMMENDATIONS_DEALER_RATING_NOT_ANSWERED
}

export const TRACKING_EVENT_CONTEXTS = {
  FAVORITES_AD_DELETED: 'favorites-ad-deleted',
  FAVORITES_LIST: 'favorites-list',
  FINANCING_CALCULATOR_CNET: 'financing-calculator-cnet',
  FINANCING_CALCULATOR: 'financing-calculator',
  FINANCING_CALCULATOR_AD_DETAIL_HASH: 'financing-calculator-ad-detail-hash',
  FINANCING_FDA_CALCULATOR: 'financing-fda-calculator',
  FINANCING_FORM_INFO: 'financing-form-info',
  FINANCING_PRICE_INFO: 'financing-price-info',
  FINANCING_LOAN_APPLICATION_FDA: 'financing-loan-application-fda',
  FINANCING_LOAN_APPLICATION_NO_FDA: 'financing-loan-application-no-fda',
  GOOGLE_LOGIN: 'google-social-login',
  APPLE_LOGIN: 'apple-social-login',
  LIST_CAROUSEL_CARD_AD: 'list-carousel-card-ad',
  LIST_CAROUSEL_CARD_NAVIGATION: 'list-carousel-card-navigation',
  LIST_CAROUSEL_MODEL_DETAIL: 'list-carousel-model-detail',
  LIST_CAROUSEL_SUBSCRIPTION_MAKE: 'list-carousel-subscription-make',
  LIST_CAROUSEL_SUBSCRIPTION_RANDOM: 'list-carousel-subscription-random',
  LISTING_AD_VIEWED: 'listing-ad-viewed',
  LISTING_FEW_RESULTS: 'listing-few-results',
  STANDARD_LOGIN: 'standard-login'
}

export const RECOMMENDED_TRACKING_EVENT_CONTEXTS = {
  [TRACKING_EVENT_CONTEXTS.FAVORITES_AD_DELETED]: 'favorites_ad_deleted',
  [TRACKING_EVENT_CONTEXTS.FAVORITES_LIST]: 'favorites_list',
  [TRACKING_EVENT_CONTEXTS.LISTING_AD_VIEWED]: 'listing_ad_viewed',
  [TRACKING_EVENT_CONTEXTS.LISTING_FEW_RESULTS]: 'listing_few_results'
}

export const TRACKING_EVENT_DATA_DEFAULT_PRODUCT = {
  ad_impression: 1,
  category: 'ads',
  highlight_type: 'not_highlighted',
  price: 0,
  quantity: 0
}

export const ADS_DETAIL_PAGE_TYPE = 'detail'
export const ADS_LIST_PAGE_TYPE = 'list'

export const TRACKING_DATA_BY_PAGE = {
  HOME: {
    channel: 'homepage',
    page_type: 'landing',
    page_category_level1: 'homepage',
    event: 'Home Viewed'
  },
  NET_ASSISTANT: {
    channel: 'assistant',
    page_type: 'form',
    page_category_level1: 'assistant',
    event: PAGE_VIEW_EVENT
  },
  NET_ASSISTANT_MENU: {
    channel: 'assistant',
    page_type: 'form',
    page_category_level1: 'assistant',
    event: PAGE_VIEW_EVENT
  },
  INSTANT_OFFER_SELL_TO_DEALER: {
    channel: 'ad post',
    event: 'Ad Insertion IO Viewed',
    page_category_level1: 'oferta instantanea',
    page_name: 'propuesta instant offer',
    page_type: 'form'
  },
  NEWS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'portada',
    event: 'List News Viewed'
  },
  NEWS_SAVED: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_name: 'listado de noticias guardadas',
    event: TRACKING_EVENT_NAMES.LIST_NEWS_SAVED_VIEWED
  },
  NEWS_DETAIL: {
    channel: 'editorial',
    page_type: 'detail',
    page_category_level1: 'noticias',
    event: 'Detail News Viewed'
  },
  NEWS_DETAIL_GALLERY: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_DETAIL_GALLERY_IMAGE: {
    channel: 'editorial',
    page_type: 'detail',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_COMMENTS: {
    channel: 'editorial',
    page_type: 'information',
    page_category_level1: 'noticias',
    event: PAGE_VIEW_EVENT
  },
  NEWS_GALLERY_SEARCH: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_RSS_FEEDS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'rss',
    event: PAGE_VIEW_EVENT
  },
  NEWS_NEWSLETTER: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'boletin',
    event: PAGE_VIEW_EVENT
  },
  NEWS_SECTION_TIPS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'consejos',
    event: 'List News Viewed'
  },
  NEWS_SECTION_TRENDS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'tendencias',
    event: 'List News Viewed'
  },
  ADS_LIST_FILTERS: {
    channel: 'ads',
    page_type: 'form',
    event: LIST_FILTERS_VIEW_EVENT
  },
  ADS_LIST: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'coches'
  },
  ADS_LIST_AUTOCARAVANS_AND_TRAILERS: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'autocaravanas y remolques'
  },
  ADS_LIST_CARS_WITHOUT_LICENSE: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'coches sin carnet'
  },
  ADS_LIST_CLASSIC_AND_COMPETITION: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'clasicos y competicion'
  },
  ADS_LIST_VANS_AND_COMMERCIAL: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'furgonetas e industriales'
  },
  ADS_LIST_SUBSCRIPTION: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'coches'
  },
  ADS_DETAIL: {
    channel: 'ads'
  },
  DEALERS_LIST: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  DEALERS_LIST_RESULTS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  MAKE: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MAKES_DISTRIBUTOR: {
    channel: 'model detail',
    page_type: 'landing',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL_INTERIOR: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL_TRUNK: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_SIZES: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - oem and model',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_MAKE_MODEL: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - oem and model',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_FUEL_TYPE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - fuel',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_TRIM_LEVEL: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - trim',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_ENGINE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - engine',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_COLOR: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - colour',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_FORM: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    page_name: 'car configurator - zip code',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_RESULTS: {
    channel: 'car configurator',
    page_category_level1: 'car configurator - final',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_ZIPCODE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_SUCCESS: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_ERROR_GENERIC: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_ERROR_CONTENT: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_CONFIGURATOR_ERROR_CONNECTION: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_BODY_TYPE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_FUEL_TYPE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_PRICE_RANGE: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_SEATS: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_MAKES: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_RESULTS: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'form',
    event: PAGE_VIEW_EVENT
  },
  VEHICLE_SUGGESTER_DETAILS: {
    channel: 'car configurator',
    page_category_level1: 'car configurator',
    page_type: 'information',
    event: PAGE_VIEW_EVENT
  },
  ERROR: {
    channel: 'others',
    page_type: 'error page',
    page_category_level1: 'error page',
    event: 'Error Page Viewed'
  },
  PROFESSIONAL_STOCK: {
    channel: 'professional stock',
    page_type: 'list',
    event: LIST_VIEW_EVENT
  },
  PROFESSIONAL_STOCK_INFO: {
    channel: 'professional stock',
    page_type: 'detail',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONAL_STOCK_RATINGS: {
    event: RATINGS_VIEWED_EVENTS
  },
  PROFESSIONALS: {
    channel: 'professional area',
    page_type: 'landing',
    page_category_level1: 'landing',
    event: PAGE_VIEW_EVENT
  },
  RECOMMENDATIONS: {
    event: LIST_VIEW_EVENT
  },
  TRANSACTION_BUYER_ONBOARDING: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_BUYER_ONBOARDING_STEP_1: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_BUYER_ONBOARDING_STEP_2: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_BUYER_ONBOARDING_STEP_3: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_BUYER_ONBOARDING_STEP_4: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_SELLER_ONBOARDING: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'seller',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_SELLER_ONBOARDING_STEP_1: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'seller',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_SELLER_ONBOARDING_STEP_2: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'seller',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_SELLER_ONBOARDING_STEP_3: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'seller',
    event: PAGE_VIEW_EVENT
  },
  TRANSACTION_SELLER_ONBOARDING_STEP_4: {
    channel: 'pay car',
    page_type: 'information',
    page_category_level1: 'onboarding',
    page_category_level2: 'seller',
    event: PAGE_VIEW_EVENT
  },
  USER_ALERTS_MATCHES: {
    channel: 'my account',
    eventName: 'List Viewed',
    pageCategoryLevel1: 'coches',
    pageName: 'novedades de alertas',
    pageType: 'list'
  },
  USER_ADS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'anuncios',
    event: 'My Ads Viewed'
  },
  USER_ADS_BUMP: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'visibilidad anuncio',
    event: 'Product List Viewed'
  },
  COMPARADOR: {
    channel: 'comparator',
    page_type: 'list',
    event: PAGE_VIEW_EVENT
  },
  USER_FAVORITE_ADS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'favoritos',
    event: PAGE_VIEW_EVENT
  },
  USER_FAVORITE_DEALERS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'favoritos',
    page_category_level2: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  USER_SAVED_SEARCHES: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'busquedas',
    event: 'My Alerts Viewed'
  },
  USER_MESSAGING: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'mensajes',
    event: 'My Messaging Inbox Viewed'
  },
  USER_PROFILE: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'cuenta',
    event: PAGE_VIEW_EVENT
  },
  USER_PROFILE_COMPLETE_PURCHASE_BUYER: {
    channel: 'paycar',
    page_type: 'information',
    page_category_level1: 'personal data',
    page_category_level2: 'buyer',
    event: PAGE_VIEW_EVENT
  },
  USER_PROFILE_EDIT: {
    channel: 'my account',
    event: 'Edit Account Viewed',
    page_category_level1: 'editar',
    page_type: 'form'
  },
  USER_ACCOUNT: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'cuenta',
    event: PAGE_VIEW_EVENT
  },
  USER_ACCOUNT_EDIT: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_ACCOUNT_DELETE: {
    channel: 'my account',
    page_type: 'popup',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_ACCOUNT_TAKE_OUT: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_VALIDATED_ACCOUNT: {
    channel: 'my account',
    page_type: 'information',
    page_category_level1: 'validacion',
    event: PAGE_VIEW_EVENT
  },
  USER_AD_DELETION_FORM: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'eliminar anuncio',
    event: PAGE_VIEW_EVENT,
    event_name: 'ad_delete_form'
  },
  USER_AD_EDIT: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'editar anuncio',
    event: PAGE_VIEW_EVENT,
    event_name: 'ad_modification_form'
  },
  USER_INCORRECT_EMAIL_OR_PHONE: {
    channel: 'ad post',
    page_type: 'information',
    page_category_level1: 'error anuncio',
    event: PAGE_VIEW_EVENT
  },
  PAYMENT_AD_REQUEST: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'segundo anuncio',
    event: 'Product List Viewed'
  },
  PAYMENT_CONFIRMATION: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'confirmacion',
    event: 'Order Completed'
  },
  SEARCH_ADVICES: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'tramites compra venta',
    event: PAGE_VIEW_EVENT
  },
  TERMS_OF_SERVICE: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'condiciones de uso',
    event: PAGE_VIEW_EVENT
  },
  DATA_PROTECTION: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'politica de privacidad',
    event: PAGE_VIEW_EVENT
  },
  VIDEOS_POLICY: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'normas de video',
    event: PAGE_VIEW_EVENT
  },
  BUYING_SAFELY: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'guia de seguridad',
    event: PAGE_VIEW_EVENT
  },
  SITEMAP: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'mapa web',
    event: PAGE_VIEW_EVENT
  },
  CONTACT: {
    channel: 'information',
    page_type: 'form',
    page_category_level1: 'contacto',
    event: PAGE_VIEW_EVENT
  },
  PUBLISH_MY_AD: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Ad Insertion Viewed'
  },
  PUBLISH_MY_AD_CATEGORY: {
    event: 'Ad Insertion Viewed',
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio'
  },
  EDIT_MY_AD: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Ad Modify Viewed'
  },
  TECHNICAL_DETAILS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'homepage',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_COMPARATOR: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_COMPARATOR_RESULTS: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_MAKE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'marca',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_MODEL: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'modelo',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_BODY_TYPE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'carroceria',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VERSION: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VEHICLE: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH_RESULTS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH_ENGINE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  COMPARISON: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  COMPARISON_RESULT: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  APPRAISAL: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'tasacion',
    event: PAGE_VIEW_EVENT
  },
  APPRAISAL_VEHICLE: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'tasacion',
    event: PAGE_VIEW_EVENT
  },
  INSPECTION_CENTERS: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'centros itv',
    event: PAGE_VIEW_EVENT
  },
  WDYL: {
    channel: 'what do you love',
    page_type: 'list',
    page_category_level1: 'what do you love',
    event: 'What Do You Love Viewed'
  },
  PROFESSIONALS_LOGIN: {
    channel: 'professional area',
    page_type: 'form',
    page_category_level1: 'login',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_REGISTER: {
    channel: 'professional area',
    page_type: 'form',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_INFO: {
    channel: 'professional area',
    page_type: 'information',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_INFO_EXTENDED: {
    channel: 'professional area',
    page_type: 'information',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  LOGIN_ERROR: {
    event: 'Signed In Error'
  },
  LINK_ACCOUNT_ERROR: {
    event: 'Signed In Error'
  },
  REGISTER_ERROR: {
    event: 'Signed Up Error'
  },
  REGISTER_VALIDATION_ERROR: {
    event: 'Signed Up Error'
  },
  COMPLETE_REGISTRATION_ERROR: {
    event: 'Signed Up Error'
  },
  FORGOT_PASSWORD_ERROR: {
    event: 'Password Email Error'
  },
  PASSWORD_RESET_ERROR: {
    event: 'Password Reseted Error'
  },
  LOGIN: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Login Viewed'
  },
  REGISTER: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Register Viewed'
  },
  FORGOT_PASSWORD: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Page Viewed'
  },
  PASSWORD_RESET: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Page Viewed'
  },
  REGISTER_SUCCESS: {
    event: 'Signed Up',
    hit_origin: 'default login',
    hit_information: 'email login'
  },
  FORGOT_PASSWORD_SEND: {
    event: 'Password Email Sent'
  },
  PASSWORD_RESET_SUCCESS: {
    event: 'Password Reseted'
  },
  CHECKOUT: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Started'
  },
  CHECKOUT_SUCCESS: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Order Completed'
  },
  CHECKOUT_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Payment Error'
  },
  CHECKOUT_PENDING: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Pending'
  },
  CHECKOUT_ACTIVATION_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Activation Error'
  },
  CHECKOUT_REFUND_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Refund Error'
  },
  CHECKOUT_REQUEST_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Request Error'
  },
  CHECKOUT_UNKNOWN_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Unknown Error'
  },
  PRODUCTS: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'visibilidad anuncio',
    event: 'Product List Viewed'
  },
  PUBLISH_YOUR_VEHICLE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Seller Selector Viewed'
  },
  PUBLISH_YOUR_VEHICLE_WITH_PLATE: {
    event: 'Ad Insertion Viewed',
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio'
  },
  LANDING_FORMALITIES: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'tramites compra venta',
    event: PAGE_VIEW_EVENT
  },
  LANDING_FORMALITIES_SECURITY_GUIDELINES: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'guia de seguridad',
    event: PAGE_VIEW_EVENT
  },
  LANDING_FINANCING: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'financiacion',
    event: PAGE_VIEW_EVENT
  },
  LANDING_INSTANT_OFFER: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'insertion datos landing instant offer pagina 1',
    event: 'Landing IO Viewed'
  },
  // web_seller_instant_offer_landing_test
  LANDING_INSTANT_OFFER_TEST: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'landing io',
    event: 'Landing IO Viewed'
  },
  LANDING_INSTANT_OFFER_TEST_VEHICLE_SELECT: {
    channel: 'ad post',
    page_category_level1: 'landing io',
    page_type: 'form',
    event: 'Landing IO Viewed'
  },
  LANDING_INSTANT_OFFER_TEST_VEHICLE_FORM: {
    channel: 'ad post',
    page_category_level1: 'landing io',
    page_type: 'form',
    event: 'Landing IO Viewed'
  },
  LANDING_INSTANT_OFFER_TEST_USER_FORM: {
    channel: 'ad post',
    page_category_level1: 'landing io',
    page_type: 'form',
    event: 'Landing IO Viewed'
  },
  VEHICLE_APPRAISER: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'tasacion',
    event: 'Page Viewed'
  },
  INSTANT_OFFER_STANDALONE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'oferta instantanea',
    event: 'Instant Offer Form Viewed'
  },
  INSTANT_OFFER_WITH_PLATE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'oferta instantanea',
    page_name: 'proceso matricula io formulario',
    event: TRACKING_EVENT_NAMES.INSTANT_OFFER_FORM_VIEWED
  },
  PUBLISH_YOUR_VEHICLE_WITH_PLATE_RESULTS: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'oferta instantanea',
    event: TRACKING_EVENT_NAMES.INSTANT_OFFER_FORM_VIEWED
  },
  INSURANCE: {
    channel: 'marketplace insurances',
    event: INSURANCES_VIEW_EVENT
  },
  DEALER_RATING_STEP_0: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_1: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_2: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_3: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_SUCCESS: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_EXPIRED: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_CLOSED: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  TRANSACTION_BUYER_LEGAL_CONDITIONS_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'legal conditions',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_LEGAL_CONDITIONS_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'legal conditions',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_ERROR: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'rapidpay',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'rapidpay',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'rapidpay',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_PRICE_NEGOTIATION_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'price negotiation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_PRICE_NEGOTIATION_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'price negotiation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DOCUMENTS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'document information',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'buyer'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DOCUMENTS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'document information',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_LEGAL_CONDITIONS_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'legal conditions',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_LEGAL_CONDITIONS_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'legal conditions',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_PRICE_NEGOTIATION_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'price negotiation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_PRICE_NEGOTIATION_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'price negotiation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  },
  TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_SUCCESS: {
    channel: 'pay car',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'identity validation',
    page_category_level2: 'seller'
  }
}
export const TRACKING_TRANSLATIONS_BY_CULTURE = {
  [DEFAULT_CULTURE]: {
    // Page Names
    ADS_DETAIL_ERROR_PAGE_NAME: 'informar de un error',
    ADS_DETAIL_PAGE_NAME: 'detail',
    ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_CALL: 'telefono',
    ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_MAIL: 'mail',
    ADS_DETAIL_RELATED_ADS_POPUP_PAGE_NAME: 'anuncios recomendados',
    ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME: 'listado de autocaravanas y remolques',
    ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME: 'listado de coches sin carnet',
    ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME: 'listado de coches clasicos y competicion',
    ADS_LIST_FILTERS_PAGE_NAME: 'filtros',
    ADS_LIST_PAGE_NAME: 'listado de coches',
    ADS_LIST_SUBSCRIPTION_PAGE_NAME: 'listado de coches por suscripcion',
    ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME: 'listado de coches por suscripcion empresas',
    ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME: 'listado de vehiculos industriales',
    APPRAISAL_PAGE_NAME: 'tasacion de coches',
    APPRAISAL_VEHICLE_PAGE_NAME: 'resultado tasacion',
    BUYING_SAFELY_PAGE_NAME: 'guia de seguridad estafas de internet como detectarlas',
    CHECKOUT_ACTIVATION_ERROR_PAGE_NAME: 'producto contratado activacion error',
    CHECKOUT_ERROR_PAGE_NAME: 'producto contratado error',
    CHECKOUT_PAGE_NAME: 'pago seguro',
    CHECKOUT_PENDING_PAGE_NAME: 'producto contratado pendiente',
    CHECKOUT_REFUND_ERROR_PAGE_NAME: 'producto contratado reembolso error',
    CHECKOUT_REQUEST_ERROR_PAGE_NAME: 'producto contratado peticion error',
    CHECKOUT_SUCCESS_PAGE_NAME: 'producto contratado',
    CHECKOUT_UNKNOWN_ERROR_PAGE_NAME: 'producto contratado error desconocido',
    COMPARISON_PAGE_NAME: 'comparador de coches nuevos y descatalogados',
    COMPARISON_RESULT_PAGE_NAME: 'resultados de la comparacion',
    CONTACT_PAGE_NAME: 'contactar cochesnet',
    DATA_PROTECTION_PAGE_NAME: 'ley de proteccion de datos',
    DEALERS_LIST_PAGE_NAME: 'busqueda de concesionario',
    DEALERS_LIST_RESULTS_PAGE_NAME: 'busqueda de concesionario',
    ERROR_PAGE_NAME: 'error page',
    FORGOT_PASSWORD_PAGE_NAME: 'mail para restablecer contraseña',
    HOME_PAGE_NAME: 'homepage',
    INSPECTION_CENTERS_PAGE_NAME: 'busca tu centro itv mas cercano',
    INSTANT_OFFER_STANDALONE_PAGE_NAME: 'insertion datos instant offer stand alone pagina 1',
    INSURANCE_PAGE_NAME: 'marketplace insurances',
    LANDING_FINANCING_PAGE_NAME: 'financiacion de la compra de un vehiculo',
    LANDING_FORMALITIES_PAGE_NAME: 'tramites para la compra-venta de coches',
    LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME: 'guia de seguridad estafas de internet como detectarlas',
    LANDING_INSTANT_OFFER_PAGE_NAME: 'landing io',
    // web_seller_instant_offer_landing_test
    LANDING_INSTANT_OFFER_TEST_PAGE_NAME: 'landing io proceso matricula',
    LANDING_INSTANT_OFFER_TEST_VEHICLE_SELECT_PAGE_NAME: 'landing io proceso matricula resultado',
    LANDING_INSTANT_OFFER_TEST_VEHICLE_FORM_PAGE_NAME: 'landing io formulario pagina 1',
    LANDING_INSTANT_OFFER_TEST_USER_FORM_PAGE_NAME: 'landing io formulario pagina 2',
    LENDO_PAGE_NAME: 'lendo',
    LOGIN_PAGE_NAME: 'inicia sesion',
    MAKE_PAGE_NAME: 'Model Detail - Make',
    MAKES_DISTRIBUTOR_PAGE_NAME: 'Model Detail',
    MODEL_DETAIL_PAGE_NAME: 'Model Detail - Model',
    MODEL_DETAIL_INTERIOR_PAGE_NAME: 'Model Detail - Interior',
    MODEL_DETAIL_TRUNK_PAGE_NAME: 'Model Detail - Maletero',
    MODEL_SIZES_PAGE_NAME: 'Model Detail - Size',
    NET_ASSISTANT_PAGE_NAME: 'net assistant',
    NET_ASSISTANT_MENU_PAGE_NAME: 'net assistant menu',
    NEWS_CATEGORY_PAGE_NAME: '%{category} de coches',
    NEWS_DETAIL_COMMENTS_PAGE_NAME: 'opiniones de noticia',
    NEWS_DETAIL_GALLERY_IMAGE_PAGE_NAME: 'detalle fotos de coches',
    NEWS_DETAIL_GALLERY_PAGE_NAME: 'galeria completa',
    NEWS_GALLERY_SEARCH_PAGE_NAME: 'fotos de coches',
    NEWS_HOME_PAGE_NAME: 'actualidad del motor',
    NEWS_NEWSLETTER_PAGE_NAME: 'boletines de coches.net',
    NEWS_RSS_FEEDS_PAGE_NAME: 'rss de las ultimas noticias de motor',
    NEWS_SEARCH_PAGE_NAME: 'actualidad del motor',
    NEWS_SECTION_TIPS_PAGE_NAME: 'consejos de coches',
    NEWS_SECTION_TRENDS_PAGE_NAME: 'tendencias de coches',
    NEWS_TAG_PAGE_NAME: 'actualidad del motor',
    NO_RESULTS_PAGE_NAME: 'listado sin resultados',
    PASSWORD_RESET_PAGE_NAME: 'restablece tu contraseña',
    PAYMENT_AD_REQUEST_PAGE_NAME: 'segundo anuncio',
    PAYMENT_CONFIRMATION_PAGE_NAME: 'producto contratado',
    PRODUCTS_PAGE_NAME: 'dale mas visibilidad a tu anuncio',
    PROFESSIONAL_STOCK_CATEGORY_LEVEL_1: 'concesionario',
    PROFESSIONAL_STOCK_INFO_PAGE_NAME: 'informacion del dealer',
    PROFESSIONAL_STOCK_PAGE_NAME: 'listado de concesionario',
    PROFESSIONAL_STOCK_INACTIVE_PAGE_NAME: 'listado de concesionario inactivo',
    PROFESSIONALS_INFO_EXTENDED_PAGE_NAME: 'pack ev basico coches mas informacion',
    PROFESSIONALS_INFO_PAGE_NAME: 'pack ev basico coches',
    PROFESSIONALS_LOGIN_PAGE_NAME: 'login',
    PROFESSIONALS_PAGE_NAME: 'landing profesionales',
    PROFESSIONALS_REGISTER_PAGE_NAME: 'crear cuenta para profesionales',
    PUBLISH_MY_AD_PAGE_NAME: 'pon tu anuncio',
    PUBLISH_MY_AD_CATEGORY_PAGE_NAME: 'seleccion categoria',
    EDIT_MY_AD_PAGE_NAME: 'editar anuncio',
    PUBLISH_YOUR_VEHICLE_PAGE_NAME: 'acceso a publicar',
    PUBLISH_YOUR_VEHICLE_WITH_PLATE_PAGE_NAME: 'proceso matricula formulario',
    PUBLISH_YOUR_VEHICLE_WITH_PLATE_RESULTS_PAGE_NAME: 'proceso matricula io resultado',
    DEALER_RATING_STEP_0_PAGE_NAME: 'user rating response check',
    DEALER_RATING_STEP_1_PAGE_NAME: 'user rating step 1 score',
    DEALER_RATING_STEP_2_PAGE_NAME: 'user rating step 2 tags',
    DEALER_RATING_STEP_3_PAGE_NAME: 'user rating step 3 review',
    DEALER_RATING_STATE_SUCCESS_PAGE_NAME: 'rating completed',
    DEALER_RATING_STATE_EXPIRED_PAGE_NAME: 'user rating expired',
    DEALER_RATING_STATE_CLOSED_PAGE_NAME: 'user rating closed',
    RECOMMENDATIONS_PAGE_NAME: 'anuncios recomendados',
    REGISTER_PAGE_NAME: 'crear cuenta',
    SEARCH_ADVICES_PAGE_NAME: 'tramites para la compra-venta de coches',
    SITEMAP_PAGE_NAME: 'mapa web de coches.net',
    TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME: 'fichas tecnicas de un modelo con carroceria',
    TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME: 'comparador de coches',
    TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME: 'comparador de coches',
    TECHNICAL_DETAILS_MAKE_PAGE_NAME: 'fichas tecnicas de una marca',
    TECHNICAL_DETAILS_MODEL_PAGE_NAME: 'fichas tecnicas de un modelo',
    TECHNICAL_DETAILS_PAGE_NAME: 'caracteristicas, precios y fotos de los modelos actuales',
    TECHNICAL_DETAILS_SEARCH_ENGINE_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_SEARCH_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_VEHICLE_PAGE_NAME: 'detalle de ficha tecnica',
    TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME: 'detalle de ficha tecnica',
    TECHNICAL_DETAILS_VERSION_PAGE_NAME: 'detalle resumen de ficha tecnica',
    TERMS_OF_SERVICE_PAGE_NAME: 'condiciones generales de uso de coches.net',
    TRANSPARENCY_PAGE_NAME: 'transparencia de Coches.net',
    TERMS_OF_SERVICE_RESERVATION_PAGE_NAME: 'condiciones del servicio de reserva de coches.net',
    TRANSACTION_BUYER_LEGAL_CONDITIONS_START_PAGE_NAME: 'Paycar Buyer Legal Conditions - Start',
    TRANSACTION_BUYER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME: 'Paycar Buyer Legal Conditions - Success',
    TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_ERROR_PAGE_NAME: 'Paycar Buyer Rapidpay Purchase - Error',
    TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_START_PAGE_NAME: 'Paycar Buyer Rapidpay Purchase - Start',
    TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_SUCCESS_PAGE_NAME: 'Paycar Buyer Rapidpay Purchase - Success',
    TRANSACTION_BUYER_PRICE_NEGOTIATION_START_PAGE_NAME: 'Paycar Buyer Price Negotiation - Start',
    TRANSACTION_BUYER_PRICE_NEGOTIATION_SUCCESS_PAGE_NAME: 'Paycar Buyer Price Negotiation - Success',
    TRANSACTION_BUYER_ONBOARDING_PAGE_NAME: 'Paycar Buyer Onboarding - Unique page',
    TRANSACTION_BUYER_ONBOARDING_STEP_1_PAGE_NAME: 'Paycar Buyer Onboarding - Buy (1/4)',
    TRANSACTION_BUYER_ONBOARDING_STEP_2_PAGE_NAME: 'Paycar Buyer Onboarding - Trust (2/4)',
    TRANSACTION_BUYER_ONBOARDING_STEP_3_PAGE_NAME: 'Paycar Buyer Onboarding - Paperwork (3/4)',
    TRANSACTION_BUYER_ONBOARDING_STEP_4_PAGE_NAME: 'Paycar Buyer Onboarding - Safe (4/4)',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DOCUMENTS_PAGE_NAME:
      'Buyer Identity Validation Flow - Document Information',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME: 'Buyer Identity Validation Flow - Start',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME: 'Buyer Identity Validation Flow - DNI Front',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME: 'Buyer Identity Validation Flow - DNI Back',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME:
      'Buyer Identity Validation Flow - Personal Data',
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME: 'Buyer Identity Validation Flow - Success',
    TRANSACTION_SELLER_ONBOARDING_PAGE_NAME: 'Paycar Seller Onboarding - Unique page',
    TRANSACTION_SELLER_ONBOARDING_STEP_1_PAGE_NAME: 'Paycar Seller Onboarding - Buy (1/4)',
    TRANSACTION_SELLER_ONBOARDING_STEP_2_PAGE_NAME: 'Paycar Seller Onboarding - Trust (2/4)',
    TRANSACTION_SELLER_ONBOARDING_STEP_3_PAGE_NAME: 'Paycar Seller Onboarding - Paperwork (3/4)',
    TRANSACTION_SELLER_ONBOARDING_STEP_4_PAGE_NAME: 'Paycar Seller Onboarding - Safe (4/4)',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME: 'Seller Identity Validation Flow - Start',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME: 'Seller Identity Validation Flow - DNI Front',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME: 'Seller Identity Validation Flow - DNI Back',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME:
      'Seller Identity Validation Flow - Personal Data',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT_PAGE_NAME:
      'Seller Identity Validation Flow - Bank Account',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DOCUMENTS_PAGE_NAME:
      'Seller Identity Validation Flow - Document Information',
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME: 'Seller Identity Validation Flow - Success',
    TRANSACTION_SELLER_LEGAL_CONDITIONS_START_PAGE_NAME: 'Paycar Seller Legal Conditions - Start',
    TRANSACTION_SELLER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME: 'Paycar Seller Legal Conditions - Success',
    TRANSACTION_SELLER_PRICE_NEGOTIATION_START_PAGE_NAME: 'Paycar Seller Price Negotiation - Start',
    TRANSACTION_SELLER_PRICE_NEGOTIATION_SUCCESS_PAGE_NAME: 'Paycar Seller Price Negotiation - Success',
    USER_ACCOUNT_DELETE_PAGE_NAME: 'borrar cuenta',
    USER_ACCOUNT_EDIT_PAGE_NAME: 'editar mis datos',
    USER_ACCOUNT_PAGE_NAME: 'mi cuenta',
    USER_ACCOUNT_TAKE_OUT_PAGE_NAME: 'take out',
    USER_AD_DELETION_FORM_PAGE_NAME: 'elimina tu anuncio',
    USER_AD_EDIT_PAGE_NAME: 'edita tu anuncio',
    USER_ADS_BUMP_PAGE_NAME: 'dale mas visibilidad a tu anuncio',
    USER_ADS_PAGE_NAME: 'mis anuncios',
    COMPARADOR_PAGE_NAME: 'comparator',
    USER_FAVORITE_ADS_PAGE_NAME: 'mis favoritos',
    USER_FAVORITE_DEALERS_PAGE_NAME: 'mis dealers favoritos',
    USER_INCORRECT_EMAIL_OR_PHONE_PAGE_NAME: 'telefono o email no valido',
    USER_MESSAGING_PAGE_NAME: 'mensajes',
    USER_PROFILE_PAGE_NAME: 'mi cuenta',
    USER_PROFILE_EDIT_PAGE_NAME: 'editar mis datos',
    USER_PROFILE_COMPLETE_PURCHASE_BUYER_PAGE_NAME: 'Identity Form - Personal data',
    USER_SAVED_SEARCHES_PAGE_NAME: 'alertas',
    USER_VALIDATED_ACCOUNT_PAGE_NAME: 'cuenta validada',
    VEHICLE_APPRAISER_PAGE_NAME: 'tasacion de coches',
    VIDEOS_POLICY_PAGE_NAME: 'normas de publicacion de imagenes y videos',
    VEHICLE_CONFIGURATOR_PAGE_NAME: 'car configurator - oem and model',
    VEHICLE_CONFIGURATOR_FUEL_TYPE_PAGE_NAME: 'car configurator - fuel',
    VEHICLE_CONFIGURATOR_ENGINE_PAGE_NAME: 'car configurator - engine',
    VEHICLE_CONFIGURATOR_TRIM_LEVEL_PAGE_NAME: 'car configurator - trim',
    VEHICLE_CONFIGURATOR_COLOR_PAGE_NAME: 'car configurator - colour',
    VEHICLE_CONFIGURATOR_FORM_PAGE_NAME: 'car configurator - zip code',
    VEHICLE_CONFIGURATOR_RESULTS_PAGE_NAME: 'car configurator - final',
    VEHICLE_CONFIGURATOR_MAKE_MODEL_PAGE_NAME: 'car configurator - oem and model',
    VEHICLE_CONFIGURATOR_ZIPCODE_PAGE_NAME: 'car configurator - zip code',
    VEHICLE_CONFIGURATOR_SUCCESS_PAGE_NAME: 'car configurator - final',
    VEHICLE_CONFIGURATOR_ERROR_GENERIC_PAGE_NAME: 'car configurator - server error',
    VEHICLE_CONFIGURATOR_ERROR_CONTENT_PAGE_NAME: 'car configurator - content error',
    VEHICLE_CONFIGURATOR_ERROR_CONNECTION_PAGE_NAME: 'car configurator - connection error',
    VEHICLE_SUGGESTER_PRICE_RANGE_PAGE_NAME: 'car configurator - price help',
    VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME: 'car configurator - body type help',
    VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME: 'car configurator - fuel type help',
    VEHICLE_SUGGESTER_SEATS_PAGE_NAME: 'car configurator - seats help',
    VEHICLE_SUGGESTER_MAKES_PAGE_NAME: 'car configurator - makes help',
    VEHICLE_SUGGESTER_RESULTS_PAGE_NAME: 'car configurator - results help',
    VEHICLE_SUGGESTER_DETAILS_PAGE_NAME: 'car configurator - view details help',
    WDYL_PAGE_NAME: 'todo lo que tenemos en cochesnet',
    // List types START
    AD_DETAIL_DEALER_ADS_LIST_TYPE: 'carrousel de detalle stock dealer',
    AD_DETAIL_RELATED_ADS_LIST_TYPE: 'carrousel detalle anuncios recomendados',
    ADS_DETAIL_RELATED_ADS_POPUP_LIST_TYPE: 'popup anuncios recomendados',
    ADS_LIST_AUTOCARAVANS_AND_TRAILERS_TYPE: 'listado de autocaravanas',
    ADS_LIST_CARS_WITHOUT_LICENSE_TYPE: 'listado de coches sin carnet',
    ADS_LIST_CLASSIC_AND_COMPETITION_TYPE: 'listado de clasicos',
    ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE: 'carrousel listado coches anuncios recomendados',
    ADS_LIST_RECOMMENDED_ADS_CAROUSEL_LIST_TYPE: 'carrousel listado 5 o menos ads anuncios recomendados',
    ADS_LIST_SUBSCRIPTION_TYPE: 'listado de coches por suscripcion',
    ADS_LIST_BUSINESS_SUBSCRIPTION_TYPE: 'listado de coches por suscripcion empresas',
    ADS_LIST_TYPE: 'listado de coches',
    ADS_LIST_VANS_AND_COMMERCIAL_TYPE: 'listado de industriales',
    ADS_PAGE_MODEL_DETAIL_LIST_TYPE: 'carrousel ads model detail',
    HOME_PAGE_MODEL_DETAIL_LIST_TYPE: 'carrousel home model detail',
    NEWS_LIST_TYPE: 'carrousel de noticias',
    PROFESSIONAL_STOCK_TYPE: 'listado de concesionario',
    SUBSCRIPTION_CAROUSEL_LIST_TYPE: 'carrousel ocasion subscription detail',
    USER_FAVORITE_ADS_TYPE: 'listado de favoritos',
    USER_FAVORITE_RECOMMENDED_ADS_CAROUSEL_LIST_TYPE: 'carrousel listado favoritos anuncios recomendados',
    USER_FAVORITE_RECOMMENDED_ADS_POPUP_LIST_TYPE: 'listado favoritos ad dropped anuncios recomendados',
    USER_FAVORITE_RECOMMENDED_ADS_POPUP_ROOT_LIST_TYPE: 'RecommendationsFavoritesDeletedAd'
    // List types END
  }
}

export const OFFER_TYPE_RENTING_TRANSLATION = {[DEFAULT_CULTURE]: 'Renting'}

export const OFFER_TYPES_TRANSLATIONS = {
  [DEFAULT_OFFER_TYPE_ID]: {[DEFAULT_CULTURE]: 'Ocasión'},
  [OFFER_TYPE_NEW]: {[DEFAULT_CULTURE]: 'Nuevo'},
  [OFFER_TYPE_KM0]: {[DEFAULT_CULTURE]: 'Km0'},
  [OFFER_TYPE_SUBSTITUTION]: {[DEFAULT_CULTURE]: 'Sustitución'},
  [OFFER_TYPE_MANAGEMENT]: {[DEFAULT_CULTURE]: 'Gerencia'},
  [OFFER_TYPE_DEMONSTRATION]: {[DEFAULT_CULTURE]: 'Demostración'},
  [OFFER_TYPE_RENTAL]: {[DEFAULT_CULTURE]: 'Alquiler'},
  [OFFER_TYPE_PRE_OWNED]: {[DEFAULT_CULTURE]: 'Seminuevo'},
  [OFFER_TYPE_SUBSCRIPTION]: {[DEFAULT_CULTURE]: 'Suscripción'}
}

export const CATEGORIES_LEVEL_1_TRANSLATIONS = {
  [SEGUNDA_MANO_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Coches'},
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    [DEFAULT_CULTURE]: 'Furgonetas e industriales'
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    [DEFAULT_CULTURE]: 'Autocaravanas y remolques'
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Coches sin carnet'},
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: {
    [DEFAULT_CULTURE]: 'Clásicos y competición'
  }
}

export const CATEGORIES_LEVEL_2_TRANSLATIONS = {
  [CATEGORY2_ID_CAR]: {[DEFAULT_CULTURE]: 'Automóvil Turismo'},
  [CATEGORY2_ID_SERVICES_GARAGE]: {[DEFAULT_CULTURE]: 'Servicios taller'},
  [CATEGORY2_ID_TUNING]: {[DEFAULT_CULTURE]: 'Tuning'},
  [CATEGORY2_ID_RENTAL]: {[DEFAULT_CULTURE]: 'Alquiler'},
  [CATEGORY2_ID_ALL_TERRAIN_VEHICLE]: {
    [DEFAULT_CULTURE]: 'Automóvil Todo Terreno'
  },
  [CATEGORY2_ID_BUS]: {[DEFAULT_CULTURE]: 'Autobuses'},
  [CATEGORY2_ID_TRUCK]: {[DEFAULT_CULTURE]: 'Camiones'},
  [CATEGORY2_ID_VAN]: {[DEFAULT_CULTURE]: 'Furgonetas'},
  [CATEGORY2_ID_LICENSES_AND_TRANSPORT_CARDS]: {
    [DEFAULT_CULTURE]: 'Licencias y tarjetas de transporte'
  },
  [CATEGORY2_ID_CLASSIC]: {[DEFAULT_CULTURE]: 'Clásicos'},
  [CATEGORY2_ID_COMPETITION]: {[DEFAULT_CULTURE]: 'Competición'},
  [CATEGORY2_ID_CARAVAN]: {[DEFAULT_CULTURE]: 'Caravanas'},
  [CATEGORY2_ID_AUTOCARAVAN]: {[DEFAULT_CULTURE]: 'Autocaravanas'},
  [CATEGORY2_ID_TRAILER_2]: {[DEFAULT_CULTURE]: 'Remolques'},
  [CATEGORY2_ID_WITHOUT_DRIVING_LICENSE]: {[DEFAULT_CULTURE]: 'Sin carnet'}
}

export const LEAD_TYPES = {
  AD_REPLIED_CHAT: 'Ad Replied Chat',
  ALERT_MATCH_AD_REPLIED_CHAT: 'Alert Match Ad Replied Chat',
  ALERT_MATCH_PHONE_CALLED: 'Alert Match Phone Called',
  APPOINTMENT_AD_REPLIED_EMAIL: 'Appointment Ad Replied Email',
  DETAIL_AD_REPLIED_CHAT: 'Detail Ad Replied Chat',
  DETAIL_AD_REPLIED_EMAIL: 'Detail Ad Replied Email',
  DETAIL_AD_REPLIED_WHATSAPP: 'Detail Ad Replied Whatsapp',
  DETAIL_FAVORITE_CHAT: 'Detail Favorite Chat',
  DETAIL_PHONE_CALLED: 'Detail Phone Called',
  FAVORITE_AD_REPLIED_CHAT: 'Favorite Ad Replied Chat',
  FAVORITE_PHONE_CALLED: 'Favorite Phone Called',
  FINANCED_PURCHASE_EMAIL: 'Financed Purchase Email',
  LAST_PICTURE_PHONE_CALLED: 'Last Picture Phone Called',
  MODEL_DETAIL_LEAD: 'Lead to OEM',
  PHONE_SENT_CHAT: 'Phone Sent Chat',
  PROFESSIONAL_LANDING_PHONE_CALLED: 'Professional Landing Phone Called',
  PROFESSIONAL_STOCK_AD_REPLIED_EMAIL: 'Professional Stock Ad Replied Email',
  PROFESSIONAL_STOCK_INFO_AD_REPLIED_EMAIL: 'Dealer Information Replied Email',
  PROFESSIONAL_STOCK_PHONE_CALLED: 'Professional Stock Phone Called',
  RECENT_SEARCH_AD_REPLIED_CHAT: 'Recent Search Ad Replied Chat',
  RECENT_SEARCH_PHONE_CALLED: 'Recent Search Phone Called',
  RECOMMENDED_AD_REPLIED_EMAIL: 'Recommended Ad Replied Email',
  RECOMMENDED_PHONE_CALLED: 'Recommended Phone Called',
  RESERVATION_PAYMENT_CONFIRMED_PHONE_CALLED: 'Reservation Payment Confirmed Phone Called',
  SAVED_FAVORITE_AD_REPLIED_CHAT: 'Saved Favorite Ad Replied Chat',
  SAVED_FAVORITE_PHONE_CALLED: 'Saved Favorite Phone Called',
  SAVED_FAVORITE_DEALER_EMAIL: 'Favorite Dealer Email',
  COMPARATOR_EMAIL: 'Comparator Email',
  COMPARATOR_PHONE_CALLED: 'Comparator Phone Called',
  NET_AD_DETAIL_EMAIL: 'Net Email',
  NET_AD_REPLIED_CHAT: 'Net Ad Replied Chat'
}

export const SORT = {
  [`${SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE}_${ORDER.DESC}`]: 'monthly_subscription_fee_max',
  [`${SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE}_${ORDER.ASC}`]: 'monthly_subscription_fee_min',
  [`${SORT_FIELDS.PRICE}_${ORDER.ASC}`]: 'price_min',
  [`${SORT_FIELDS.PRICE}_${ORDER.DESC}`]: 'price_max',
  [`${SORT_FIELDS.INSTALMENT}_${ORDER.ASC}`]: 'financing_instalment_min',
  [`${SORT_FIELDS.INSTALMENT}_${ORDER.DESC}`]: 'financing_instalment_max',
  [`${SORT_FIELDS.KM}_${ORDER.ASC}`]: 'km_min',
  [`${SORT_FIELDS.KM}_${ORDER.DESC}`]: 'km_max',
  [`${SORT_FIELDS.YEAR}_${ORDER.DESC}`]: 'new_cars',
  [`${SORT_FIELDS.YEAR}_${ORDER.ASC}`]: 'older_cars',
  [`${SORT_FIELDS.FINANCED_PRICE}_${ORDER.DESC}`]: 'financed_price_max',
  [`${SORT_FIELDS.FINANCED_PRICE}_${ORDER.ASC}`]: 'financed_price_min',
  [`${SORT_FIELDS.RELEVANCE}_${ORDER.DESC}`]: 'new_ads',
  [`${SORT_FIELDS.RELEVANCE}_${ORDER.ASC}`]: 'older_ads'
}

export const SELLER_TYPES_TRANSLATIONS = {
  [SELLER_TYPE_PROFESSIONAL]: {[DEFAULT_CULTURE]: 'profesional'},
  [SELLER_TYPE_PRIVATE]: {[DEFAULT_CULTURE]: 'particular'}
}

// Translations of the driven wheels filters for ads-list tracking
export const TRACKING_DRIVEN_WHEELS_FILTERS_TRANSLATIONS = {
  [DRIVEN_WHEELS_ALL_ID]: {[DEFAULT_CULTURE]: 'Integral (AWD, 4WD, 4x4)'},
  [DRIVEN_WHEELS_FRONT_ID]: {
    [DEFAULT_CULTURE]: 'Delantera (FWD)'
  },
  [DRIVEN_WHEELS_REAR_ID]: {[DEFAULT_CULTURE]: 'Trasera (RWD)'}
}

// Translations of the fuel types filters for ads-list tracking
export const TRACKING_FUEL_TYPES_FILTERS_TRANSLATIONS = {
  [FUEL_TYPE_DIESEL_ID]: {[DEFAULT_CULTURE]: 'diésel'},
  [FUEL_TYPE_GASOLINE_ID]: {[DEFAULT_CULTURE]: 'gasolina'},
  [FUEL_TYPE_ELECTRIC_ID]: {[DEFAULT_CULTURE]: 'eléctrico'},
  [FUEL_TYPE_HYBRID_ID]: {[DEFAULT_CULTURE]: 'híbrido'},
  [FUEL_TYPE_HYBRID_PLUG_IN_ID]: {[DEFAULT_CULTURE]: 'híbrido enchufable'},
  [FUEL_TYPE_GLP_ID]: {[DEFAULT_CULTURE]: 'gas licuado (glp)'},
  [FUEL_TYPE_CNG_ID]: {[DEFAULT_CULTURE]: 'gas natural (cng)'},
  [FUEL_TYPE_OTHER_ID]: {[DEFAULT_CULTURE]: 'otros'}
}

// Translations of the environmental labels filters for ads-list tracking
export const TRACKING_ENVIRONMENTAL_LABELS_FILTERS_TRANSLATIONS = {
  [ENVIRONMENTAL_LABELS_0_ID]: {[DEFAULT_CULTURE]: 'Etiqueta CERO (azul)'},
  [ENVIRONMENTAL_LABELS_ECO_ID]: {
    [DEFAULT_CULTURE]: 'Etiqueta ECO (azul/verde)'
  },
  [ENVIRONMENTAL_LABELS_C_ID]: {[DEFAULT_CULTURE]: 'Etiqueta C (verde)'},
  [ENVIRONMENTAL_LABELS_B_ID]: {[DEFAULT_CULTURE]: 'Etiqueta B (amarilla)'}
}

export const BODY_TYPES_TRANSLATIONS = {
  [BODY_TYPE_SEDAN_ID]: {[DEFAULT_CULTURE]: 'Berlina'},
  [BODY_TYPE_COUPE_ID]: {[DEFAULT_CULTURE]: 'Coupe'},
  [BODY_TYPE_CABRIO_ID]: {[DEFAULT_CULTURE]: 'Cabrio'},
  [BODY_TYPE_FAMILIAR_ID]: {[DEFAULT_CULTURE]: 'Familiar'},
  [BODY_TYPE_MINIVAN_ID]: {[DEFAULT_CULTURE]: 'Monovolumen'},
  [BODY_TYPE_4X4_ID]: {[DEFAULT_CULTURE]: 'SUV'},
  [BODY_TYPE_PICK_UP_ID]: {[DEFAULT_CULTURE]: 'Pick Up'},
  [BODY_TYPE_VANS_ID]: {[DEFAULT_CULTURE]: 'Furgoneta'}
}

export const STOCK_TAB_NAME = {
  VEHICLES: 'vehicles',
  INFORMATION: 'information',
  RATINGS: 'ratings'
}

export const CATEGORY_ID_1_TO_PAGE_NAME_DICTIONARY = {
  [SEGUNDA_MANO_CATEGORY1_ID]: 'ads-list',
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: 'ads-list-vans-and-commercial',
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: 'ads-list-autocaravans-and-trailers',
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: 'ads-list-cars-without-license',
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: 'ads-list-classic-and-competition'
}

export const TRANSMISSION_TRANSLATIONS = {
  [TRANNSMISSION_TYPE_ID_AUTOMATIC]: {[DEFAULT_CULTURE]: 'automático'},
  [TRANNSMISSION_TYPE_ID_MANUAL]: {[DEFAULT_CULTURE]: 'manual'}
}

export const LUGGAGE_CAPACITY_TRANSLATIONS = {
  [LUGGAGE_CAPACITY_SMALL.id]: {[DEFAULT_CULTURE]: 'Pequeño <200L'},
  [LUGGAGE_CAPACITY_MEDIUM.id]: {
    [DEFAULT_CULTURE]: 'Mediano 200L - 400L'
  },
  [LUGGAGE_CAPACITY_LARGE.id]: {[DEFAULT_CULTURE]: 'Grande >400L'}
}

export const TRACKING_FILTERS_PAYMENT_TYPES_TRANSLATIONS = {
  CASH: 'contado',
  FINANCED: 'financiado',
  INSTALMENT: 'cuota mensual'
}

export const TRACKING_FILTERS_OFFER_TYPES_TRANSLATIONS = {
  [OFFER_TYPE_SECOND_HAND]: {[DEFAULT_CULTURE]: 'segunda-mano'},
  [OFFER_TYPE_NEW]: {[DEFAULT_CULTURE]: 'nuevo'},
  [OFFER_TYPE_KM0]: {[DEFAULT_CULTURE]: 'km0'},
  [OFFER_TYPE_SUBSTITUTION]: {[DEFAULT_CULTURE]: 'km0'},
  [OFFER_TYPE_MANAGEMENT]: {[DEFAULT_CULTURE]: 'km0'},
  [OFFER_TYPE_DEMONSTRATION]: {[DEFAULT_CULTURE]: 'km0'},
  [OFFER_TYPE_RENTAL]: {[DEFAULT_CULTURE]: 'km0'},
  [OFFER_TYPE_PRE_OWNED]: {[DEFAULT_CULTURE]: 'km0'}
}

export const COLOR_TRANSLATIONS = {
  [COLORS_ID.YELLOW]: {[DEFAULT_CULTURE]: 'Amarillo'},
  [COLORS_ID.BLUE]: {[DEFAULT_CULTURE]: 'Azul'},
  [COLORS_ID.BEIGE]: {[DEFAULT_CULTURE]: 'Beige'},
  [COLORS_ID.WHITE]: {[DEFAULT_CULTURE]: 'Blanco'},
  [COLORS_ID.GARNET]: {[DEFAULT_CULTURE]: 'Granate'},
  [COLORS_ID.GRAY]: {[DEFAULT_CULTURE]: 'Gris / Plata'},
  [COLORS_ID.BROWN]: {[DEFAULT_CULTURE]: 'Marrón'},
  [COLORS_ID.ORANGE]: {[DEFAULT_CULTURE]: 'Naranja'},
  [COLORS_ID.BLACK]: {[DEFAULT_CULTURE]: 'Negro'},
  [COLORS_ID.RED]: {[DEFAULT_CULTURE]: 'Rojo'},
  [COLORS_ID.PINK]: {[DEFAULT_CULTURE]: 'Rosa'},
  [COLORS_ID.GREEN]: {[DEFAULT_CULTURE]: 'Verde'},
  [COLORS_ID.PURPLE]: {[DEFAULT_CULTURE]: 'Violeta / Lila'}
}

export const PRICE_RANK_TRANSLATIONS = {
  ...PRICE_INDICATOR_LABEL_RANK
}

export const SDRN_BASE = 'sdrn:coches.net:user:'

export const DEFAULT_CALL_TRACKING_SERVICE = CALL_TRACKING_SERVICES.FREESPEE

export const SESSION_TRACKING_IDENTIFIED_USER_KEY_PREFIX = 'tracking_identified_user_coches_'

export const TRACKING_OS_NAME_ANDROID = 'Android'
export const TRACKING_OS_NAME_IOS = 'iOS'

export const TRACKING_OS_NAMES = {
  android: TRACKING_OS_NAME_ANDROID,
  ios: TRACKING_OS_NAME_IOS
}

export const TRACKING_HAS_PRICEDROP_TRUE = 'with_price_drop'
export const TRACKING_HAS_PRICEDROP_FALSE = 'without_price_drop'
